/* Safety Cover repair 2026-09-12: main engine and UI are one file. */
/* ==========================================================================
   Pool Busters — Safety Cover Design Centre
   Calculator engine + page interactions.

   Contains NO prices. Every dollar figure is read at runtime from
   assets/pbsc-sc-pricing.json. Money is handled in integer cents.
   ========================================================================== */
/* Progressive enhancement marker: this line only runs if the whole file
   parsed. The stylesheet keeps every reveal/scrub element visible until the
   marker exists, so a missing or truncated script leaves a fully readable
   static page instead of hidden content. */

(function () {
  'use strict';

  /* The asset snippet is rendered by every section, so guard against the
     script being evaluated more than once on a page. */
  if (typeof window !== 'undefined') {
    if (window.__PBSC_SC_LOADED__) return;
    window.__PBSC_SC_LOADED__ = true;
  }

  var ROOT_SEL = '[data-pbsc-root]';
  var SS_KEY = 'pbsc.sc.quote.v1';

  /* ---------------------------------------------------------------- utils */
  function $(s, c) { return (c || document.getElementById('pbsc-sc-root') || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document.getElementById('pbsc-sc-root') || document).querySelectorAll(s)); }
  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }
  function cents(n) { return Math.round(Number(n) * 100); }
  var fmt = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' });
  var fmt0 = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD', maximumFractionDigits: 0, minimumFractionDigits: 0 });
  /* launch pass: estimates read to the dollar ("$2,019"), never to the cent.
     Anything under $100 (an anchor, a cut-out) keeps its cents. */
  function money(c) { return Math.abs(c) >= 10000 ? fmt0.format(Math.round(c / 100)) : fmt.format(c / 100); }
  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  function store(obj) {
    try { sessionStorage.setItem(SS_KEY, JSON.stringify(obj)); } catch (e) {}
  }
  function restore() {
    try { return JSON.parse(sessionStorage.getItem(SS_KEY) || 'null'); } catch (e) { return null; }
  }
  function esc(s) { return String(s == null ? '' : s); }

  /* ------------------------------------------------- shape line-art glyphs */
  var GLYPH = {
    rectangular: 'M8 14 H92 V58 H8 Z',
    roman: 'M8 14 H74 A22 22 0 0 1 74 58 H8 Z',
    grecian: 'M20 14 H80 L92 26 V46 L80 58 H20 L8 46 V26 Z',
    octagon: 'M34 12 H66 L88 30 V42 L66 60 H34 L12 42 V30 Z',
    oval: 'M30 14 H70 A22 22 0 0 1 70 58 H30 A22 22 0 0 1 30 14 Z',
    round: 'M50 14 A22 22 0 1 1 49.9 14 Z',
    kidney: 'M22 16 C6 24 6 48 24 56 C42 63 58 52 68 52 C84 52 94 44 92 32 C90 18 74 10 60 16 C48 21 36 10 22 16 Z',
    nassau: 'M12 14 H62 C82 14 94 26 92 38 C90 52 74 60 58 56 C44 52 30 60 20 56 C10 52 10 30 12 14 Z',
    teardrop: 'M14 36 C14 20 30 12 50 14 C74 16 90 26 90 36 C90 48 72 60 50 58 C30 56 14 50 14 36 Z',
    squarel: 'M8 14 H56 V36 H92 V58 H8 Z',
    lazyl: 'M8 14 H56 C58 28 66 36 92 36 V58 H8 Z',
    diamond: 'M22 14 H78 L92 36 L78 58 H22 L8 36 Z',
    kite: 'M12 22 L60 12 L92 36 L60 60 L12 50 Z',
    monaco: 'M14 20 C26 12 74 12 86 22 C94 30 90 48 78 54 C62 62 30 60 18 52 C8 45 8 27 14 20 Z',
    californian: 'M10 26 C20 14 46 12 62 16 C82 21 94 30 90 42 C86 54 62 62 42 58 C22 54 4 40 10 26 Z',
    freeform: 'M16 24 C24 12 48 10 62 18 C74 25 92 22 92 34 C92 48 74 60 54 58 C36 56 26 62 16 52 C6 43 8 34 16 24 Z',
    other: 'M50 12 A24 24 0 1 1 49.9 12 M50 44 v2 M50 26 a5 5 0 1 1 0 10'
  };
  /* Client-facing material names. The engine's internal values stay
     'standard' / 'premium'; customers only ever see these. */
  var QLABEL = { standard: 'Standard Mesh', premium: 'Premium High Density Mesh' };

  function glyph(id) {
    var d = GLYPH[id] || GLYPH.other;
    return '<svg viewBox="0 0 100 72" aria-hidden="true" focusable="false">' +
      '<path d="' + d + '" fill="none" stroke="currentColor" stroke-width="1.4" ' +
      'stroke-linejoin="round" stroke-linecap="round"/></svg>';
  }

  /* ==================================================================
     CALCULATOR
     ================================================================== */
  function Calculator(root, DB, opts) {
    this.root = root;
    this.DB = DB;
    this.opts = opts || {};
    this.SP = DB.service_pricing;
    this.colours = [];
    if (typeof document !== 'undefined') {
      var cs = $('[data-pbsc-colours]', document);
      if (cs) { try { this.colours = JSON.parse(cs.textContent) || []; } catch (e) { this.colours = []; } }
    }

    this.state = Object.assign(blankState(), restore() || {});

    this.g = 0;
    this.build();
    if (!this.opts.headless) { this.bindReset(); this.render(); }
  }

  /* One definition of "nothing chosen yet", used by the constructor and by
     Start over — two copies would drift, and the one that drifts is the one
     that only runs when somebody asks to start again. */
  function blankState() {
    return {
      intent: null, template: null, shape: null, deck: null, size: null,
      hasSteps: null, stepPos: '', stepType: '', stepDims: '',
      grid: null, quality: null, colour: null,
      cutLadder: 0, cutRock: 0, obstruction: 'no', obstructionNote: '',
      wantsInstall: null, anchorState: null, anchorQty: 0, wantsClosing: null
    };
  }

  Calculator.prototype.bindReset = function () {
    var C = this;
    $$('[data-pbsc-reset]', document).forEach(function (b) {
      b.addEventListener('click', function () {
        C.state = blankState();
        C.clearFormSummary();
        C.g = 0;
        C.save();
        C.render();
        C.focusPanel();
      });
    });
  };

  Calculator.prototype.shapeById = function (id) {
    return this.DB.shapes.filter(function (s) { return s.id === id; })[0] || null;
  };

  /* Rows available for the current shape (+ deck choice) */
  Calculator.prototype.rows = function () {
    var s = this.shapeById(this.state.shape);
    if (!s) return [];
    var key = s.table;
    if (s.deckSplit) {
      if (!this.state.deck) return [];
      key = s.deckTables[this.state.deck];
    }
    if (!key) return [];
    var rows = this.DB.tables[key] || [];
    if (s.rows) {
      var allow = s.rows;
      rows = rows.filter(function (r) { return allow.indexOf(r.pool) !== -1; });
    }
    return rows;
  };

  Calculator.prototype.sizeLabel = function (r) {
    var s = this.shapeById(this.state.shape);
    if (s && s.sizeField === 'actual' && r.actual) return r.actual;
    return r.pool;
  };
  Calculator.prototype.sizeSub = function (r) {
    var s = this.shapeById(this.state.shape);
    if (s && s.sizeField === 'actual' && r.actual && r.actual !== r.pool) {
      return 'catalogue size ' + r.pool;
    }
    return '';
  };

  Calculator.prototype.row = function () {
    var self = this;
    return this.rows().filter(function (r) { return self.sizeLabel(r) === self.state.size; })[0] || null;
  };

  Calculator.prototype.gridsFor = function (r) {
    if (!r) return [];
    var g = [];
    if (r.opts['5x5|no'] || r.opts['5x5|yes']) g.push('5x5');
    if (r.opts['3x3|no'] || r.opts['3x3|yes']) g.push('3x3');
    return g;
  };

  Calculator.prototype.opt = function () {
    var r = this.row();
    if (!r || !this.state.grid || this.state.hasSteps == null) return null;
    return r.opts[this.state.grid + '|' + (this.state.hasSteps ? 'yes' : 'no')] || null;
  };

  Calculator.prototype.premiumAllowed = function () {
    var o = this.opt();
    return !!(o && o.prem != null && this.DB.rules.premium_grids.indexOf(this.state.grid) !== -1);
  };

  Calculator.prototype.isManual = function () {
    var s = this.shapeById(this.state.shape);
    if (!s) return null;
    if (s.manual) return 'We don’t have a stock pattern on file for this pool shape.';
    if (this.state.size === '__NONE__') return 'Your pool size isn’t one of the stock sizes CoverWerx builds to pattern.';
    if (this.state.size && !this.row()) return 'We couldn’t match that size to a stock pattern.';
    if (this.state.size && this.state.grid && this.state.hasSteps != null && !this.opt()) {
      return 'That combination of grid and step configuration isn’t available in this size.';
    }
    return null;
  };

  /* ------------------------------------------------------- step definitions */
  Calculator.prototype.build = function () {
    var C = this;
    this.steps = [

      { id: 'intent', nav: 'Cover',
        legend: 'Is this your first safety cover, or a replacement?',
        help: 'Replacement covers usually reuse the anchors already set into your deck, which changes what the installation costs.',
        render: function (w) {
          C.radios(w, 'intent', [
            { v: 'new', t: 'My first safety cover', d: 'No safety cover anchors in the deck yet.' },
            { v: 'replacement', t: 'Replacing an existing cover', d: 'Anchors are already installed around the pool.' }
          ], C.state.intent, 'pbsc-opts--2');
        },
        valid: function () { return C.state.intent ? null : 'Please choose one option to continue.'; } },

      { id: 'template', nav: 'Template',
        show: function () { return C.state.intent === 'replacement'; },
        legend: 'Do you still have the old cover, or a template made from it?',
        help: 'If a usable template already exists, we don’t need to charge for a custom measurement.',
        render: function (w) {
          C.radios(w, 'template', [
            { v: 'yes', t: 'Yes', d: 'I have the old cover or its template.' },
            { v: 'no', t: 'No', d: 'Nothing to measure from.' },
            { v: 'unsure', t: 'Not sure', d: 'We’ll confirm this with you.' }
          ], C.state.template);
        },
        valid: function () { return C.state.template ? null : 'Please choose one option to continue.'; } },

      { id: 'shape', nav: 'Shape',
        legend: 'What shape is your pool?',
        help: 'Choose the outline that matches your pool. If nothing looks right, pick the last option and we’ll take it from there.',
        render: function (w) {
          var opts = C.DB.shapes.map(function (s) {
            return { v: s.id, t: s.label, d: s.blurb, glyph: s.id };
          });
          C.radios(w, 'shape', opts, C.state.shape, 'pbsc-opts--tiles');
        },
        valid: function () { return C.state.shape ? null : 'Please choose a pool shape to continue.'; } },

      { id: 'deck', nav: 'Deck',
        show: function () { var s = C.shapeById(C.state.shape); return !!(s && s.deckSplit); },
        legend: 'What is the deck around your pool made of?',
        help: 'Round pools are covered differently depending on whether the anchors go into concrete or into a wood deck.',
        render: function (w) {
          C.radios(w, 'deck', [
            { v: 'concrete', t: 'Concrete deck', d: 'Anchors set into concrete.' },
            { v: 'wood', t: 'Wood deck', d: 'Anchors set into a wood surround.' }
          ], C.state.deck, 'pbsc-opts--2');
        },
        valid: function () { return C.state.deck ? null : 'Please choose one option to continue.'; } },

      { id: 'size', nav: 'Size',
        legend: 'What size is your pool?',
        help: 'Measure the water’s edge at the longest and widest points. We confirm every measurement on site before anything is ordered.',
        render: function (w) {
          var rows = C.rows();
          var f = el('div', 'pbsc-field');
          var lb = el('label', null, 'Pool size'); lb.setAttribute('for', 'pbsc-size');
          var sel = el('select', 'pbsc-select'); sel.id = 'pbsc-size'; sel.name = 'size';
          sel.appendChild(new Option('Select your pool size…', ''));
          var sh = C.shapeById(C.state.shape);
          rows.forEach(function (r) {
            var lbl = C.sizeLabel(r);
            var sub = C.sizeSub(r);
            sel.appendChild(new Option(lbl + (sub ? '  (' + sub + ')' : ''), lbl));
          });
          sel.appendChild(new Option('My size isn’t listed', '__NONE__'));
          sel.value = C.state.size || '';
          sel.addEventListener('change', function () {
            C.state.size = sel.value || null;
            C.state.grid = null; C.state.quality = null;
            C.save(); C.render();
          });
          f.appendChild(lb); f.appendChild(sel);
          if (sh && sh.sizeField === 'actual') {
            f.appendChild(el('p', 'pbsc-hint',
              'Kidney pools are listed by the size you’ll actually measure. The catalogue size in brackets is the manufacturer’s own reference.'));
          } else {
            f.appendChild(el('p', 'pbsc-hint',
              'These are the sizes CoverWerx builds to a stock pattern. Anything else is quoted by hand.'));
          }
          w.appendChild(f);

          var r = C.row();
          if (r) {
            var n = el('div', 'pbsc-note');
            n.innerHTML = '<strong>Cover size for this pool:</strong> ' + esc(r.cover) +
              '. The cover is deliberately larger than the pool so it can anchor into the deck.';
            w.appendChild(n);
          }
        },
        valid: function () { return C.state.size ? null : 'Please choose your pool size to continue.'; } },

      { id: 'steps', nav: 'Steps',
        show: function () { return !C.isManual(); },
        legend: 'Does your pool have steps or a bench?',
        help: 'A step section is an extra panel added to the cover so it reaches out over the steps.',
        render: function (w) {
          C.radios(w, 'hasSteps', [
            { v: '1', t: 'Yes, it has steps', d: 'Roman, wedding-cake, swim-out or bench.' },
            { v: '0', t: 'No steps', d: 'The cover follows the pool edge only.' }
          ], C.state.hasSteps == null ? null : (C.state.hasSteps ? '1' : '0'), 'pbsc-opts--2', function (v) {
            C.state.hasSteps = v === '1';
            C.state.grid = null;
          });
        },
        valid: function () { return C.state.hasSteps == null ? 'Please choose one option to continue.' : null; } },

      { id: 'stepdetail', nav: 'Step detail',
        show: function () { return C.state.hasSteps === true && !C.isManual(); },
        legend: 'Tell us about the steps',
        help: 'This doesn’t change your estimate — it goes to the crew who measure and build the cover, so the step panel is right the first time.',
        render: function (w) {
          C.text(w, 'stepPos', 'Where are the steps?', 'e.g. shallow end, left-hand side', 'select', [
            '', 'Shallow end', 'Deep end', 'Left side', 'Right side', 'Corner', 'More than one location'
          ]);
          C.text(w, 'stepType', 'What shape are they?', '', 'select', [
            '', 'Rectangular', 'Roman / curved', 'Wedding cake', 'Corner radius', 'Swim-out or bench', 'Not sure'
          ]);
          C.text(w, 'stepDims', 'Rough size, if you know it', 'e.g. 8 ft wide × 4 ft out');
          w.appendChild(el('p', 'pbsc-hint',
            'Estimates are unaffected by these answers — step pricing is a single fixed section charge.'));
        },
        valid: function () { return null; } },

      { id: 'grid', nav: 'Grid',
        show: function () {
          if (C.isManual()) return false;
          return C.gridsFor(C.row()).length > 1;
        },
        legend: 'Which strap grid would you like?',
        help: 'The grid is the webbing layout across the cover — separate from the mesh itself. Not every pool shape supports both.',
        render: function (w) {
          var r = C.row(), avail = C.gridsFor(r);
          var opts = [];
          if (avail.indexOf('3x3') !== -1) opts.push({ v: '3x3', t: '3×3 grid',
            d: 'A denser webbing layout with more anchors. Required for Premium High Density Mesh, and commonly required for freeform and complex shapes.' });
          if (avail.indexOf('5x5') !== -1) opts.push({ v: '5x5', t: '5×5 grid',
            d: 'A wider webbing layout using fewer straps and anchors, for a cleaner, less visually dense grid. Standard Mesh only.' });
          C.radios(w, 'grid', opts, C.state.grid, 'pbsc-opts--2', function (v) {
            C.state.grid = v;
            if (v === '5x5' && C.state.quality === 'premium') {
              C.state.quality = 'standard';
              C.flash = 'Premium High Density Mesh is only built on a 3×3 grid, so your material has been set back to Standard Mesh. Both carry the same safety strength and the same lifetime pro-rated warranty.';
            }
          });
        },
        valid: function () { return C.state.grid ? null : 'Please choose a grid to continue.'; } },

      { id: 'quality', nav: 'Material',
        show: function () { return !C.isManual() && !!C.row(); },
        legend: 'Standard Mesh, or Premium High Density Mesh?',
        help: 'Both carry the same CoverWerx safety strength and the same lifetime pro-rated workmanship warranty. The difference is weave density \u2014 how much fine debris and sunlight gets through \u2014 and which grid it can be built on.',
        render: function (w) {
          var o = C.opt();
          var opts = [{ v: 'standard', t: 'Standard Mesh',
            d: 'CoverWerx\u2019s more open weave. Drains rain and meltwater faster, lighter to handle, and available on either grid.' }];
          if (C.premiumAllowed()) {
            opts.push({ v: 'premium', t: 'Premium High Density Mesh',
              d: 'A tighter weave that filters more fine dust and lets less sunlight through. Same safety strength, same warranty. 3\u00d73 only.' });
          }
          C.radios(w, 'quality', opts, C.state.quality, 'pbsc-opts--2');
          if (!C.premiumAllowed() && C.state.grid === '5x5') {
            var n = el('div', 'pbsc-note');
            n.textContent = 'Premium High Density Mesh isn’t shown here because CoverWerx builds it on a 3×3 grid only. Go back a step to switch grids if you’d like to compare it.';
            w.appendChild(n);
          }
          if (o) {
            var p = el('div', 'pbsc-note');
            p.innerHTML = '<strong>Cover price for this configuration:</strong> Standard ' + money(cents(o.std)) +
              (o.prem != null ? '  ·  Premium ' + money(cents(o.prem)) : '') +
              '. Installation is quoted separately, further down.';
            w.appendChild(p);
          }
        },
        valid: function () { return C.state.quality ? null : 'Please choose a material to continue.'; } },

      { id: 'colour', nav: 'Colour',
        show: function () { return C.colours.length > 0 && !C.isManual(); },
        legend: 'Choose your mesh colour',
        help: 'All five CoverWerx colours are available in both Standard Mesh and Premium High Density Mesh.',
        render: function (w) {
          var ul = el('ul', 'pbsc-swatches');
          C.colours.forEach(function (c) {
            var li = el('li', 'pbsc-swatch');
            var b = el('button', 'pbsc-swatch__btn');
            b.type = 'button';
            b.id = 'pbsc-colour-' + c.name.toLowerCase().replace(/[^a-z]/g, '');
            b.setAttribute('aria-pressed', String(C.state.colour === c.name));
            var chip = el('span', 'pbsc-swatch__chip');
            if (c.image) { chip.style.backgroundImage = 'url("' + c.image + '")'; }
            else if (c.hex) { chip.style.background = c.hex; }
            var meta = el('span', 'pbsc-swatch__meta');
            meta.appendChild(el('span', 'pbsc-swatch__name', c.name));
            meta.appendChild(el('span', 'pbsc-swatch__note', c.note || 'Select'));
            b.appendChild(chip); b.appendChild(meta);
            b.addEventListener('click', function () {
              C.state.colour = c.name; C.save();
              document.dispatchEvent(new CustomEvent('pbsc-sc:colour', { detail: c.name }));
              C.render();
            });
            li.appendChild(b); ul.appendChild(li);
          });
          w.appendChild(ul);
          var d = el('p', 'pbsc-hint');
          d.style.marginTop = 'calc(var(--pbsc-rem, 16px) * 1.2)';
          d.textContent = 'Material colours may appear differently on screen. Ask Pool Busters to view an actual mesh sample before finalizing your order.';
          w.appendChild(d);
        },
        valid: function () { return C.state.colour ? null : 'Please choose a colour to continue.'; } },

      { id: 'extras', nav: 'Cut-outs',
        show: function () { return !C.isManual(); },
        legend: 'Anything the cover has to work around?',
        help: 'Ladders, slide legs and diving rocks need a finished cut-out. Larger obstructions are priced after we see them.',
        render: function (w) {
          C.number(w, 'cutLadder', 'Ladder or slide-leg cut-outs', 0, 12,
            'Each finished cut-out is a fixed charge.');
          C.number(w, 'cutRock', 'Diving rock cut-outs (up to 4 ft)', 0, 6, '');
          C.radios(w, 'obstruction', [
            { v: 'no', t: 'Nothing else in the way', d: 'The cover runs clean to the deck all the way round.' },
            { v: 'yes', t: 'There’s an obstruction', d: 'A raised wall, planter, rock feature, tree or similar.' }
          ], C.state.obstruction, 'pbsc-opts--2');
          if (C.state.obstruction === 'yes') {
            C.text(w, 'obstructionNote', 'Describe it for us',
              'What it is, roughly where it sits, and how far along the pool it runs', 'textarea');
            var n = el('div', 'pbsc-note');
            n.innerHTML = '<strong>Send us a photo and we’ll price this part by hand.</strong> ' +
              'Your estimate includes a set allowance towards working around it. What it actually takes ' +
              'depends on the method and how far it runs, so we confirm that from a photo rather than guessing — ' +
              'attach one to your reply, or bring it to the consultation. Everything else in your estimate is unaffected.';
            w.appendChild(n);
          }
        },
        valid: function () { return null; } },

      { id: 'services', nav: 'Services',
        legend: 'Would you like Pool Busters to take care of it?',
        help: 'Completely optional, and priced separately from the cover. Plenty of customers buy the cover on its own and fit it themselves.',
        render: function (w) {
          C.radios(w, 'wantsInstall', [
            { v: 'yes', t: 'Yes, please quote installation', d: 'We measure, fit and tension the cover.' },
            { v: 'no', t: 'Cover only', d: 'Just the product — no labour, no services.' }
          ], C.state.wantsInstall, 'pbsc-opts--2', null, 'Safety cover installation');

          if (C.state.wantsInstall === 'yes') {
            if (C.state.intent === 'replacement') {
              C.radios(w, 'anchorState', [
                { v: 'all_good', t: 'All anchors are in good shape', d: 'Nothing to replace.' },
                { v: 'known', t: 'Some need replacing — I know how many', d: 'We’ll price them individually.' },
                { v: 'unknown', t: 'Some may need replacing — not sure how many', d: 'We’ll confirm the count on site.' }
              ], C.state.anchorState, '', null, 'How are your existing anchors?');
              if (C.state.anchorState === 'known') {
                C.number(w, 'anchorQty', 'How many anchors need replacing?', 0, 120,
                  'Removing and resetting an existing anchor takes more work than setting a new one, so it is priced separately.');
              }
            } else {
              var o = C.opt();
              if (o) {
                var an = el('div', 'pbsc-note');
                an.innerHTML = '<strong>Anchors for this cover:</strong> approximately ' + o.anchors +
                  '. New anchor installation is charged per anchor and appears as its own line in your estimate.';
                w.appendChild(an);
              }
            }
          }

          C.radios(w, 'wantsClosing', [
            { v: 'yes', t: 'Yes, close the pool too', d: C.state.wantsInstall === 'yes'
                ? 'Reduced rate when booked alongside cover work.' : 'Standard closing service.' },
            { v: 'no', t: 'No thanks', d: '' }
          ], C.state.wantsClosing, 'pbsc-opts--2', null, 'Add a pool closing?');
        },
        valid: function () {
          if (!C.state.wantsInstall) return 'Please tell us whether you’d like installation quoted.';
          if (C.state.wantsInstall === 'yes' && C.state.intent === 'replacement' && !C.state.anchorState) {
            return 'Please tell us about your existing anchors.';
          }
          if (!C.state.wantsClosing) return 'Please tell us whether you’d like a pool closing added.';
          return null;
        } },

      { id: 'result', nav: 'Estimate', isResult: true, legend: '', render: function () {} }
    ];
  };

  /* -------------------------------------------------------- field builders */
  Calculator.prototype.radios = function (wrap, key, opts, current, cls, after, label) {
    var C = this;
    if (label) {
      var l = el('p', 'pbsc-lbl', label);
      l.style.marginTop = 'calc(var(--pbsc-rem, 16px) * 1.9)';
      wrap.appendChild(l);
    }
    var g = el('div', 'pbsc-opts ' + (cls || ''));
    g.setAttribute('role', 'radiogroup');
    if (label) g.setAttribute('aria-label', label);
    g.style.marginTop = label ? 'calc(var(--pbsc-rem, 16px) * .7)' : '';
    opts.forEach(function (o, idx) {
      var id = 'pbsc-' + key + '-' + idx;
      var lab = el('label', 'pbsc-opt');
      var inp = el('input');
      inp.type = 'radio'; inp.name = 'pbsc-' + key; inp.id = id; inp.value = o.v;
      inp.checked = String(current) === String(o.v);
      if (o.disabled) inp.disabled = true;
      var face = el('span', 'pbsc-opt__face');
      if (o.glyph) {
        var gl = el('span', 'pbsc-opt__shape');
        gl.innerHTML = glyph(o.glyph);
        face.appendChild(gl);
      }
      face.appendChild(el('span', 'pbsc-opt__t', o.t));
      if (o.d) face.appendChild(el('span', 'pbsc-opt__d', o.d));
      inp.addEventListener('change', function () {
        if (after) { after(o.v); } else { C.state[key] = o.v; }
        if (key === 'shape') { C.state.size = null; C.state.deck = null; C.state.grid = null; C.state.quality = null; }
        if (key === 'deck') { C.state.size = null; C.state.grid = null; C.state.quality = null; }
        C.save(); C.render();
      });
      lab.appendChild(inp); lab.appendChild(face);
      g.appendChild(lab);
    });
    wrap.appendChild(g);
  };

  Calculator.prototype.text = function (wrap, key, label, ph, type, choices) {
    var C = this;
    var f = el('div', 'pbsc-field');
    var id = 'pbsc-f-' + key;
    var l = el('label', null, label); l.setAttribute('for', id);
    var inp;
    if (type === 'select') {
      inp = el('select', 'pbsc-select');
      (choices || []).forEach(function (c) { inp.appendChild(new Option(c || 'Select…', c)); });
    } else if (type === 'textarea') {
      inp = el('textarea', 'pbsc-textarea');
    } else {
      inp = el('input', 'pbsc-input'); inp.type = 'text';
    }
    inp.id = id; inp.name = key;
    if (ph) inp.placeholder = ph;
    inp.value = C.state[key] || '';
    inp.addEventListener('input', function () { C.state[key] = inp.value; C.save(); C.updateRail(); });
    inp.addEventListener('change', function () { C.state[key] = inp.value; C.save(); C.updateRail(); });
    f.appendChild(l); f.appendChild(inp);
    wrap.appendChild(f);
  };

  Calculator.prototype.number = function (wrap, key, label, min, max, hint) {
    var C = this;
    var f = el('div', 'pbsc-field');
    var id = 'pbsc-f-' + key;
    var l = el('label', null, label); l.setAttribute('for', id);
    var inp = el('input', 'pbsc-input');
    inp.type = 'number'; inp.id = id; inp.name = key; inp.min = min; inp.max = max; inp.step = 1;
    inp.inputMode = 'numeric';
    inp.value = C.state[key] != null ? C.state[key] : 0;
    inp.style.maxWidth = '200px';
    inp.addEventListener('input', function () {
      var v = parseInt(inp.value, 10);
      if (isNaN(v) || v < min) v = min;
      if (v > max) v = max;
      C.state[key] = v; inp.value = String(v); C.save(); C.updateRail();
    });
    f.appendChild(l); f.appendChild(inp);
    if (hint) f.appendChild(el('p', 'pbsc-hint', hint));
    wrap.appendChild(f);
  };

  /* --------------------------------------------------------------- pricing */
  /* Some pools offer only one strap grid, and the grid question is hidden in
     that case — correctly, since there is nothing to choose. But nothing ever
     adopted the single answer, so state.grid stayed null, opt() found no
     priced option, and a pool with a perfectly good stock price was reported
     as needing a hand-built quote. An oval 14 x 28 is one: 3x3 only, priced,
     and it read "Custom quote".

     So: fill in any choice the pool leaves no alternative for, and clear one
     the pool no longer supports, before anything reads the state. Called from
     both entry points — render() for the page, quote() for the price — so a
     headless caller gets the same answer as the page does. */
  Calculator.prototype.settle = function () {
    var r = this.row();
    if (!r) return;
    var grids = this.gridsFor(r);
    if (!grids.length) return;
    if (grids.length === 1) {
      if (this.state.grid !== grids[0]) this.state.grid = grids[0];
    } else if (this.state.grid && grids.indexOf(this.state.grid) === -1) {
      this.state.grid = null;
    }
    /* premium exists only on some grids; a grid change can strand it */
    if (this.state.quality === 'premium' && !this.premiumAllowed()) {
      this.state.quality = 'standard';
    }
  };

  Calculator.prototype.quote = function () {
    this.settle();
    var S = this.state, SP = this.SP, DB = this.DB;
    var manual = this.isManual();
    var q = {
      manual: manual, product: [], service: [], productTotal: 0, serviceTotal: 0,
      spec: [], notes: [], tbd: []
    };

    var sh = this.shapeById(S.shape);
    var r = this.row();
    var o = this.opt();

    /* Premium exists on 3x3 only. If the customer moved to 5x5 while Premium
       was selected, fall back to Standard and say so rather than failing. */
    if (S.quality === 'premium' && !this.premiumAllowed()) {
      S.quality = 'standard';
      q.notes.push('CoverWerx builds Premium High Density Mesh on a 3×3 grid only, so this estimate uses Standard Mesh.');
      q.reverted = true;
    }

    /* ---- spec ---- */
    if (sh) q.spec.push(['Pool shape', sh.label + (S.deck ? ' — ' + S.deck + ' deck' : '')]);
    if (S.size && S.size !== '__NONE__') q.spec.push(['Pool size', S.size + ' ft']);
    if (r) q.spec.push(['Cover size', r.cover + ' ft']);
    if (S.grid) q.spec.push(['Strap grid', S.grid.replace('x', '×')]);
    if (S.quality) q.spec.push(['Material', QLABEL[S.quality] || 'Standard Mesh']);
    q.spec.push(['Step section', S.hasSteps ? 'Included' : 'Not required']);
    if (S.colour) q.spec.push(['Colour', S.colour]);
    if (o) q.spec.push(['Anchors', 'Approximately ' + o.anchors]);
    q.spec.push(['Cover type', S.intent === 'replacement' ? 'Replacement cover' : 'First safety cover']);

    /* ---- product ---- */
    if (!manual && o) {
      var base = S.quality === 'premium' ? o.prem : o.std;
      if (base == null) { q.manual = 'That material isn’t available in this configuration.'; }
      else {
        q.product.push({
          lbl: 'CoverWerx safety cover — ' + (sh ? sh.label : '') + ' ' + S.size + ' ft',
          sub: r.cover + ' ft cover · ' + S.grid.replace('x', '×') + ' grid · ' +
               (QLABEL[S.quality] || 'Standard Mesh') +
               (S.hasSteps ? ' · step section included' : ''),
          amt: cents(base)
        });
      }
    }
    if (!q.manual) {
      if (S.cutLadder > 0) {
        q.product.push({ lbl: 'Ladder or slide-leg cut-out', sub: S.cutLadder + ' × ' + money(cents(DB.cutouts.ladder_slide_leg)),
          amt: cents(DB.cutouts.ladder_slide_leg) * S.cutLadder });
      }
      if (S.cutRock > 0) {
        q.product.push({ lbl: 'Diving rock cut-out', sub: S.cutRock + ' × ' + money(cents(DB.cutouts.diving_rock)),
          amt: cents(DB.cutouts.diving_rock) * S.cutRock });
      }
      /* An obstruction is service work, not part of the cover, so it belongs
         in the service column. The spec sets a fixed Pool Busters allowance
         and then routes the rest to manual review rather than letting the
         calculator invent a figure for work nobody has seen yet. */
    }
    q.productTotal = q.product.reduce(function (a, l) { return a + (l.amt || 0); }, 0);

    /* ---- service ---- */
    if (!q.manual && (S.wantsInstall === 'yes' || S.wantsClosing === 'yes')) {
      var coverWork = false;
      if (S.wantsInstall === 'yes' && S.intent === 'replacement') {
        q.service.push({ lbl: 'Safety cover refit', sub: 'Fitting your new cover to the anchors already in your deck.', amt: cents(SP.refit) });
        coverWork = true;
        if (S.anchorState === 'known' && S.anchorQty > 0) {
          q.service.push({ lbl: 'Replacement anchors', sub: S.anchorQty + ' × ' + money(cents(SP.replacement_anchor_each)) + ' — removing and resetting an existing anchor',
            amt: cents(SP.replacement_anchor_each) * S.anchorQty });
        } else if (S.anchorState === 'unknown') {
          q.service.push({ lbl: 'Replacement anchors, if required', sub: money(cents(SP.replacement_anchor_each)) + ' each — subject to site verification', tbd: true });
          q.tbd.push('anchors');
        }
      } else if (S.wantsInstall === 'yes' && o) {
        q.service.push({ lbl: 'Safety cover installation — base', sub: 'Layout, fitting and final tensioning.', amt: cents(SP.install_base) });
        q.service.push({ lbl: 'New anchor installation', sub: o.anchors + ' × ' + money(cents(SP.new_anchor_each)),
          amt: cents(SP.new_anchor_each) * o.anchors });
        coverWork = true;
      }

      /* measure — only attaches to an installation */
      var hasTemplate = (S.intent === 'replacement' && S.template === 'yes');
      if (S.wantsInstall === 'yes' && !hasTemplate) {
        q.service.push({ lbl: 'Custom safety-cover measure', sub: 'Required because there is no existing template to build from.', amt: cents(SP.custom_measure) });
        /* Obstructions are deliberately NOT in this list any more: they carry
           their own allowance below, and the two are the same $100. Counting
           both would charge twice for one obstruction. */
        var complex = (sh && sh.complexMeasure) || S.cutLadder > 0 || S.cutRock > 0;
        if (complex) {
          q.service.push({ lbl: 'Complex measurement surcharge',
            sub: (sh && sh.complexMeasure ? 'Freeform outline' : 'Cut-outs or obstruction') + ' — additional measuring time.',
            amt: cents(SP.complex_measure_surcharge) });
        }
      } else if (S.wantsInstall === 'yes') {
        q.notes.push('No custom measurement charge — you already have a usable template.');
      }

      if (S.obstruction === 'yes') {
        q.service.push({
          lbl: 'Obstruction service allowance',
          sub: 'A set allowance towards working around it. The rest is confirmed from your photo before anything is booked.',
          amt: cents(SP.obstruction_allowance)
        });
        q.tbd.push('obstruction');
      }

      if (S.wantsClosing === 'yes') {
        var closing = coverWork ? SP.closing_with_cover_work : SP.closing_regular;
        q.service.push({ lbl: 'Pool closing', sub: coverWork ? 'Reduced rate, booked alongside your cover work.' : 'Standard closing rate.', amt: cents(closing) });
      }
    }
    q.serviceTotal = q.service.reduce(function (a, l) { return a + (l.amt || 0); }, 0);
    q.overall = q.productTotal + q.serviceTotal;
    /* Defensive: a priced estimate must always carry a real cover price. If
       anything ever leaves the product column empty without an explanation,
       route to a hand-built quote rather than showing a $0 figure. */
    if (!q.manual && q.productTotal <= 0) {
      q.manual = 'We couldn’t price this combination automatically.';
    }
    return q;
  };

  /* ---------------------------------------------------------------- render */
  Calculator.prototype.visibleSteps = function () {
    var C = this;
    return this.steps.filter(function (s) { return !s.show || s.show(); });
  };

  Calculator.prototype.save = function () { store(this.state); };

  /* The estimate is the page's state, not the calculator's. Anything that
     wants to follow it listens for this instead of reaching into the
     Calculator — today that is the cover study, which rebuilds its model so
     the cover on screen is the cover being priced. Published from render(),
     which is the one choke point every state change already passes through. */
  Calculator.prototype.publish = function () {
    if (this.opts.headless || typeof document === 'undefined') return;
    if (typeof CustomEvent !== 'function') return;
    var st = this.state;
    var sig = [st.shape, st.size, st.grid, st.quality, st.colour, st.hasSteps].join('|');
    if (sig === this._sig) return;
    this._sig = sig;
    document.dispatchEvent(new CustomEvent('pbsc-sc:config', { detail: {
      shape: st.shape, size: st.size, grid: st.grid,
      quality: st.quality, colour: st.colour, hasSteps: st.hasSteps
    } }));
  };

  /* ------------------------------------------------------- step groupings */
  /* The estimator asks exactly the questions it always asked, in the same
     order, with the same visibility rules, the same validation and the same
     pricing. What changed is the shape of the thing: four named movements
     instead of thirteen numbered screens, so a visitor is building a cover
     rather than working through a form.

     GROUPS is a presentation map over step ids and nothing else. A step id
     that is not listed here simply never appears, so adding a step means
     adding it to a group — which is the intended failure mode: a new
     question cannot quietly go missing from the page without also going
     missing from this list, where it is obvious. */
  var GROUPS = [
    { key: 'pool', n: '01', label: 'Your pool',
      lede: 'What are we covering? Only what the next answer actually depends on.',
      steps: ['intent', 'template', 'shape', 'deck', 'size', 'steps', 'stepdetail'] },
    { key: 'cover', n: '02', label: 'Your cover',
      lede: 'The grid, the mesh and the colour — the cover itself.',
      steps: ['grid', 'quality', 'colour', 'extras'] },
    { key: 'services', n: '03', label: 'Your services',
      lede: 'Taking the cover on its own is always an option.',
      steps: ['services'] },
    { key: 'quote', n: '04', label: 'Your quote', lede: '',
      steps: ['result'] }
  ];

  /* The visible steps, bucketed. A group with nothing visible in it — no
     round pool, so no deck question — drops out entirely rather than
     rendering an empty movement. */
  Calculator.prototype.groups = function () {
    var vis = this.visibleSteps();
    return GROUPS.map(function (g) {
      return {
        key: g.key, n: g.n, label: g.label, lede: g.lede,
        steps: vis.filter(function (s) { return g.steps.indexOf(s.id) !== -1; })
      };
    }).filter(function (g) { return g.steps.length > 0; });
  };

  /* The first unanswered question before group `upto`, or null. This is the
     whole of the group's gate: validation still lives on each step, exactly
     as before, and is simply asked of several steps at once. */
  Calculator.prototype.firstGap = function (groups, upto) {
    for (var i = 0; i < upto && i < groups.length; i++) {
      var st = groups[i].steps;
      for (var k = 0; k < st.length; k++) {
        if (st[k].isResult) continue;
        var msg = st[k].valid ? st[k].valid() : null;
        if (msg) return { group: i, step: st[k], msg: msg };
      }
    }
    return null;
  };

  Calculator.prototype.groupIndex = function (groups, key) {
    for (var i = 0; i < groups.length; i++) if (groups[i].key === key) return i;
    return 0;
  };

  /* ---------------------------------------------------------------- render */
  Calculator.prototype.render = function () {
    var C = this;
    this.settle();
    this.publish();
    var groups = this.groups();
    if (this.g == null) this.g = 0;
    if (this.g >= groups.length) this.g = groups.length - 1;
    if (this.g < 0) this.g = 0;
    var group = groups[this.g];

    /* Answering a question rebuilds the panel, because a later question may
       have just appeared or disappeared. With one question per screen that
       cost nothing; with a whole movement on screen it would throw focus to
       the top on every answer, so focus is put back where it was. */
    var act = typeof document !== 'undefined' ? document.activeElement : null;
    var keep = act && act.id && this.root.contains(act) ? act.id : null;

    /* progress */
    var bar = $('[data-pbsc-bar] i', this.root);
    if (bar) {
      bar.style.width = groups.length > 1
        ? Math.round((this.g / (groups.length - 1)) * 100) + '%' : '100%';
    }
    var cnt = $('[data-pbsc-count]', this.root);
    if (cnt) cnt.textContent = group.n + ' / ' + ('0' + groups.length).slice(-2);
    var ttl = $('[data-pbsc-stepname]', this.root);
    if (ttl) ttl.textContent = group.label;

    /* movement nav */
    var dots = $('[data-pbsc-dots]', this.root);
    if (dots) {
      dots.innerHTML = '';
      groups.forEach(function (g, idx) {
        var b = el('button');
        b.type = 'button';
        b.appendChild(el('span', null, g.n));
        b.appendChild(el('em', null, g.label));
        if (idx === C.g) b.setAttribute('aria-current', 'step');
        if (idx < C.g) b.setAttribute('data-done', '1');
        if (idx > C.g && C.firstGap(groups, idx)) b.disabled = true;
        b.addEventListener('click', function () {
          var gap = idx > C.g ? C.firstGap(groups, idx) : null;
          if (gap) { C.jumpTo(groups, gap); return; }
          C.g = idx; C.render(); C.focusPanel();
        });
        dots.appendChild(b);
      });
    }

    /* panel */
    var panel = $('[data-pbsc-panel]', this.root);
    panel.innerHTML = '';

    if (group.key === 'quote') {
      this.renderResult(panel);
      this.updateRail();
      return;
    }

    var head = el('div', 'pbsc-calc__ghd');
    var h = el('p', 'pbsc-calc__gh', group.label);
    h.setAttribute('tabindex', '-1');
    h.setAttribute('data-pbsc-legend', '');
    head.appendChild(h);
    if (group.lede) head.appendChild(el('p', 'pbsc-calc__glede', group.lede));
    panel.appendChild(head);

    var hasSize = false;
    group.steps.forEach(function (step) {
      if (step.id === 'size') hasSize = true;
      var fs = el('fieldset', 'pbsc-fs');
      fs.setAttribute('data-step', step.id);
      var lg = el('legend', null, step.legend);
      fs.appendChild(lg);
      if (step.help) fs.appendChild(el('p', 'pbsc-fs__help', step.help));
      var body = el('div');
      step.render(body);
      fs.appendChild(body);
      var serr = el('div', 'pbsc-err');
      serr.setAttribute('data-pbsc-serr', step.id);
      serr.hidden = true;
      serr.setAttribute('role', 'alert');
      fs.appendChild(serr);
      panel.appendChild(fs);
    });

    if (this.flash) {
      var fl = el('div', 'pbsc-note');
      fl.setAttribute('role', 'status');
      fl.textContent = this.flash;
      panel.appendChild(fl);
      this.flash = null;
    }

    var m = this.isManual();
    if (m && hasSize) {
      var mn = el('div', 'pbsc-note');
      mn.innerHTML = '<strong>We’ll quote this one by hand.</strong> ' + esc(m) +
        ' Keep going — we’ll still collect everything and one of our team will price it properly.';
      panel.appendChild(mn);
    }

    var nav = el('div', 'pbsc-nav');
    if (this.g > 0) {
      var back = el('button', 'pbsc-btn pbsc-btn--ghost pbsc-btn--sm', 'Back');
      back.type = 'button';
      back.addEventListener('click', function () { C.g--; C.render(); C.focusPanel(); });
      nav.appendChild(back);
    }
    nav.appendChild(el('span', 'pbsc-spacer'));
    var nextGroup = groups[this.g + 1];
    var next = el('button', 'pbsc-btn',
      nextGroup && nextGroup.key === 'quote' ? 'See my estimate'
        : nextGroup ? 'Continue to ' + nextGroup.label.toLowerCase()
          : 'Continue');
    next.type = 'button';
    next.addEventListener('click', function () {
      var gap = C.firstGap(groups, C.g + 1);
      if (gap) { C.jumpTo(groups, gap); return; }
      C.g++; C.render(); C.focusPanel();
    });
    nav.appendChild(next);
    panel.appendChild(nav);

    /* An unanswered question found from another movement is reported here,
       after that movement has been rendered. */
    if (this.pendingErr) {
      var pe = this.pendingErr;
      this.pendingErr = null;
      var box = $('[data-pbsc-serr="' + pe.id + '"]', panel);
      if (box) { box.hidden = false; box.textContent = pe.msg; }
      var fsx = $('[data-step="' + pe.id + '"]', panel);
      if (fsx) {
        var f = fsx.querySelector('input:not([disabled]),select,textarea,button');
        if (f) f.focus({ preventScroll: true });
        if (fsx.scrollIntoView) {
          fsx.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'center' });
        }
      }
      keep = null;
    } else if (keep) {
      var again = document.getElementById(keep);
      if (again && again.focus) again.focus({ preventScroll: true });
    }

    this.updateRail();
  };

  /* Send the visitor to the unanswered question, wherever it is. */
  Calculator.prototype.jumpTo = function (groups, gap) {
    this.pendingErr = { id: gap.step.id, msg: gap.msg };
    if (gap.group !== this.g) { this.g = gap.group; }
    this.render();
  };

  Calculator.prototype.focusPanel = function () {
    var lg = $('[data-pbsc-legend]', this.root) || $('[data-pbsc-panel] h2', this.root);
    if (lg) { lg.focus({ preventScroll: true }); }
    var stage = this.root.matches('[data-pbsc-stage]') ? this.root : $('[data-pbsc-stage]', this.root);
    if (stage) {
      var nav = document.querySelector('[data-pbsc-subnav]');
      var top = stage.getBoundingClientRect().top + window.pageYOffset - (nav ? nav.getBoundingClientRect().height : 64) - 16 - (parseFloat(getComputedStyle(document.getElementById('pbsc-sc-root')).getPropertyValue('--pbsc-sticky-offset')) || 0);
      window.scrollTo({ top: top, behavior: reduceMotion() ? 'auto' : 'smooth' });
    }
  };

  /* ------------------------------------------------------------ result view */
  Calculator.prototype.renderResult = function (panel) {
    var C = this, q = this.quote(), S = this.state;

    var h = el('h2');
    h.setAttribute('tabindex', '-1');
    h.setAttribute('data-pbsc-legend', '');
    h.style.cssText = 'font-family:var(--pb-display);font-variation-settings:var(--pb-wonk);' +
      'font-weight:340;font-size:clamp(calc(var(--pbsc-rem, 16px) * 1.6),3vw,calc(var(--pbsc-rem, 16px) * 2.4));line-height:1.06;letter-spacing:-.026em;margin:0 0 calc(var(--pbsc-rem, 16px) * .5);color:var(--s-fg);';
    h.textContent = q.manual ? 'Your pool needs a hand-built quote' : 'Your safety cover estimate';
    panel.appendChild(h);
    var study = el('div', 'pbsc-result-study');
    study.innerHTML = '<div class="pbsc-draw" data-pbsc-draw></div><p><strong>Your cover specification</strong><span data-pbsc-draw-cap></span><br>Illustrative study. Final fit and measurements are confirmed before ordering.</p>';
    panel.appendChild(study);
    this.drawPool(study);

    if (q.manual) {
      var mw = el('div', 'pbsc-manual');
      mw.style.marginTop = 'calc(var(--pbsc-rem, 16px) * 1.5)';
      mw.appendChild(el('h3', null, 'Custom quote required'));
      mw.appendChild(el('p', null, q.manual));
      mw.appendChild(el('p', null, 'That isn’t a problem — it just means the price comes from a person rather than a table. We’ve kept everything you entered. Send it over and we’ll come back to you with a proper figure.'));
      var sp = el('dl', 'pbsc-spec');
      q.spec.forEach(function (p) {
        var d = el('div'); d.appendChild(el('dt', null, p[0])); d.appendChild(el('dd', null, p[1])); sp.appendChild(d);
      });
      mw.appendChild(sp);
      var mb = el('button', 'pbsc-btn', 'Send this to Pool Busters');
      mb.type = 'button';
      mb.addEventListener('click', function () { C.toBooking(q); });
      mw.appendChild(mb);
      panel.appendChild(mw);
      this.pushToForm(q);
      return;
    }

    var wrap = el('div', 'pbsc-quote');
    wrap.style.marginTop = 'calc(var(--pbsc-rem, 16px) * 1.8)';

    /* --- product --- */
    var pb = el('div', 'pbsc-qblock');
    var ph = el('div', 'pbsc-qblock__hd');
    var pht = el('div');
    pht.appendChild(el('p', 't', 'Safety cover — product'));
    pht.appendChild(el('p', 'st', 'The cover itself. No labour included.'));
    ph.appendChild(pht);
    pb.appendChild(ph);
    var pbd = el('div', 'pbsc-qblock__bd');
    var sp2 = el('dl', 'pbsc-spec');
    q.spec.forEach(function (p) {
      var d = el('div'); d.appendChild(el('dt', null, p[0])); d.appendChild(el('dd', null, p[1])); sp2.appendChild(d);
    });
    pbd.appendChild(sp2);
    pbd.appendChild(this.lines(q.product));
    pbd.appendChild(this.subtotal('Product subtotal', q.productTotal));
    pb.appendChild(pbd);
    wrap.appendChild(pb);

    /* --- service --- */
    var sb = el('div', 'pbsc-qblock');
    var shh = el('div', 'pbsc-qblock__hd');
    var sht = el('div');
    var stt = el('p', 't', 'Optional services'); sht.appendChild(stt);
    sht.appendChild(el('p', 'st', q.service.length ? 'Selected by you — removable at any time.' : 'Not selected.'));
    shh.appendChild(sht);
    var tog = el('button', 'pbsc-btn pbsc-btn--ghost pbsc-btn--sm',
      q.service.length ? 'Remove services' : 'Add installation');
    tog.type = 'button';
    tog.addEventListener('click', function () {
      C.g = C.groupIndex(C.groups(), 'services');
      if (q.service.length) { S.wantsInstall = 'no'; S.wantsClosing = 'no'; C.save(); C.render(); }
      else { C.render(); C.focusPanel(); }
    });
    shh.appendChild(tog);
    sb.appendChild(shh);
    var sbd = el('div', 'pbsc-qblock__bd');
    if (q.service.length) {
      sbd.appendChild(this.lines(q.service));
      if (q.notes.length) {
        q.notes.forEach(function (n) { sbd.appendChild(el('p', 'pbsc-hint', n)); });
      }
      sbd.appendChild(this.subtotal('Services subtotal', q.serviceTotal));
    } else {
      sbd.appendChild(el('p', 'pbsc-body',
        'You haven’t added any services. The cover can absolutely be purchased on its own — many of our customers fit it themselves.'));
      sbd.appendChild(this.subtotal('Services subtotal', 0, 'None selected'));
    }
    sb.appendChild(sbd);
    wrap.appendChild(sb);

    /* --- overall --- */
    var ob = el('div', 'pbsc-qblock pbsc-qblock--total');
    var ohh = el('div', 'pbsc-qblock__hd');
    var oht = el('div');
    oht.appendChild(el('p', 't', 'Estimated overall total'));
    oht.appendChild(el('p', 'st', 'Product plus any services you selected'));
    ohh.appendChild(oht);
    ob.appendChild(ohh);
    var obd = el('div', 'pbsc-qblock__bd');
    obd.appendChild(this.lines([
      { lbl: 'Safety cover — product', amt: q.productTotal },
      q.service.length
        ? { lbl: 'Optional services', amt: q.serviceTotal }
        : { lbl: 'Optional services', sub: 'None selected', dash: true }
    ]));
    obd.appendChild(this.subtotal('Estimated overall total', q.overall));
    ob.appendChild(obd);
    wrap.appendChild(ob);

    panel.appendChild(wrap);

    /* --- disclaimers --- */
    var dis = el('div', 'pbsc-callout pbsc-callout--warn');
    dis.style.marginTop = 'calc(var(--pbsc-rem, 16px) * 1.8)';
    dis.appendChild(el('h4', null, 'About this estimate'));
    var dp = el('p');
    dp.innerHTML = 'This is an estimate, not an invoice. ' + esc(this.DB.rules.tax_note) +
      ' Every measurement is verified before a cover is ordered, and your final price is confirmed in writing first.' +
      (q.tbd.length ? ' Items marked <em>to be confirmed</em> are not included in the totals above.' : '');
    dis.appendChild(dp);
    panel.appendChild(dis);

    /* --- actions --- */
    var nav = el('div', 'pbsc-nav');
    var back = el('button', 'pbsc-btn pbsc-btn--ghost pbsc-btn--sm', 'Change my answers');
    back.type = 'button';
    back.addEventListener('click', function () { C.g = Math.max(0, C.g - 1); C.render(); C.focusPanel(); });
    nav.appendChild(back);
    var pr = el('button', 'pbsc-btn pbsc-btn--ghost pbsc-btn--sm', 'Print or save');
    pr.type = 'button';
    pr.addEventListener('click', function () { window.print(); });
    nav.appendChild(pr);
    nav.appendChild(el('span', 'pbsc-spacer'));
    var go = el('button', 'pbsc-btn', 'Request this safety cover');
    go.type = 'button';
    go.addEventListener('click', function () { C.toBooking(q); });
    nav.appendChild(go);
    panel.appendChild(nav);

    this.pushToForm(q);
  };

  Calculator.prototype.lines = function (arr) {
    var ul = el('ul', 'pbsc-lines');
    arr.forEach(function (l) {
      var li = el('li');
      if (l.tbd) li.setAttribute('data-tbd', '1');
      var lb = el('span', 'lbl');
      lb.appendChild(document.createTextNode(l.lbl));
      if (l.sub) lb.appendChild(el('span', 'sub', l.sub));
      li.appendChild(lb);
      li.appendChild(el('span', 'amt', l.tbd ? 'To be confirmed' : (l.dash ? '—' : money(l.amt || 0))));
      ul.appendChild(li);
    });
    return ul;
  };
  Calculator.prototype.subtotal = function (label, c, none) {
    var d = el('div', 'pbsc-sub');
    d.appendChild(el('span', 'lbl', label));
    /* "none" marks an intentionally empty column: an em-dash reads as
       "nothing here", where $0.00 reads as a pricing failure. */
    d.appendChild(el('span', 'amt pbsc-num', none && !c ? '—' : money(c)));
    return d;
  };

  /* --------------------------------------------------------- summary rail */
  /* ------------------------------------------------------- the plan view */
  /* A line drawing of the pool being configured, with the webbing grid laid
     over it and the cover's overlap shown outside the waterline — the same
     "cut to your pool, not trimmed to fit" point the page makes in words,
     made once in a drawing. It reuses the page's own shape glyphs, so the
     outline in the summary is the outline on the shape tiles; there is no
     second set of shapes to keep in step.

     Illustrative, not to scale, and it says so. Nothing here is measured
     and nothing here feeds the price. */
  var drawSeq = 0;
  Calculator.prototype.drawPool = function (rail) {
    var host = $('[data-pbsc-draw]', rail), cap = $('[data-pbsc-draw-cap]', rail);
    if (!host) return;
    var S = this.state;
    if (!S.shape) {
      host.innerHTML = ''; host.setAttribute('data-empty','1');
      if (cap) cap.textContent = 'Choose your pool shape to begin.';
      return;
    }
    host.removeAttribute('data-empty');
    if (!host.id) host.id = 'pbsc-draw-' + (++drawSeq);
    var uid = host.id, d = GLYPH[S.shape] || GLYPH.other;
    var swatch = this.colours.filter(function(c){return c.name === S.colour;})[0];
    var colour = swatch && /^#[a-f0-9]{6}$/i.test(swatch.hex || '') ? swatch.hex : '#8A9290';
    var pitch = S.grid === '5x5' ? 10 : 6;
    var weave = S.quality === 'premium' ? .75 : 1.3;
    var selected = !!S.colour;
    var sh = this.shapeById(S.shape);
    var description = [sh ? sh.label : 'Custom outline', S.colour || 'Finish not selected', S.quality === 'premium' ? 'Premium High Density Mesh' : S.quality === 'standard' ? 'Standard Mesh' : 'Material not selected'].join(' · ');
    host.innerHTML = '<svg viewBox="-12 -8 124 92" role="img" aria-label="'+esc(description)+'. Illustrative, not to scale.">' +
      '<defs><pattern id="'+uid+'-w" width="'+weave+'" height="'+weave+'" patternUnits="userSpaceOnUse"><path d="M'+weave+' 0H0V'+weave+'" fill="none" stroke="#fff" stroke-opacity=".2" stroke-width=".16"/></pattern>'+ 
      '<pattern id="'+uid+'-g" width="'+pitch+'" height="'+pitch+'" patternUnits="userSpaceOnUse"><path d="M'+pitch+' 0H0V'+pitch+'" fill="none" stroke="#1c302d" stroke-opacity=".85" stroke-width=".68"/></pattern>'+
      '<clipPath id="'+uid+'-c"><path d="'+d+'"/></clipPath></defs>'+
      '<path d="M-5 3H105M-5 75H105M0 -2V80M100 -2V80" stroke="#b6bbb2" stroke-width=".22" fill="none"/>'+
      '<path d="'+d+'" fill="none" stroke="#78877c" stroke-dasharray="1.5 1.5" stroke-width=".4" transform="translate(-2 -1.45) scale(1.04)"/>'+
      '<path d="'+d+'" fill="'+colour+'" fill-opacity="'+(selected ? '.94' : '.28')+'" stroke="#233d36" stroke-width=".7"/>'+
      '<g clip-path="url(#'+uid+'-c)"><rect x="-6" y="-6" width="112" height="88" fill="url(#'+uid+'-w)"/>'+
      '<rect x="-6" y="-6" width="112" height="88" fill="url(#'+uid+'-g)"/></g>'+
      '<path d="M8 68H92M8 65v6M92 65v6" stroke="#66776c" stroke-width=".4" fill="none"/>'+
      '<text x="50" y="76" text-anchor="middle" fill="#4d5c53" font-family="Manrope, sans-serif" font-size="3">'+esc(S.size && S.size !== '__NONE__' ? S.size+' ft · waterline' : 'Measured to your pool')+'</text></svg>';
    if (cap) {
      var bits=[sh ? sh.label : 'Custom outline'];
      if(S.colour) bits.push(S.colour);
      if(S.quality) bits.push(S.quality === 'premium' ? 'Premium mesh' : 'Standard mesh');
      if(S.grid) bits.push(S.grid.replace('x','×')+' grid');
      cap.textContent=bits.join(' · ');
    }
  };


  Calculator.prototype.updateRail = function () {
    if(this.firstGap(this.groups(),3)){this.clearFormSummary();}else{this.pushToForm(this.quote());}

    var C = this, q = this.quote(), S = this.state;
    var rails = $$('[data-pbsc-rail]', document);
    rails.forEach(function (rail) {
      C.drawPool(rail);
      var v = $('[data-pbsc-rail-total]', rail);
      var s = $('[data-pbsc-rail-sub]', rail);
      var list = $('[data-pbsc-rail-list]', rail);
      var empty = $('[data-pbsc-rail-empty]', rail);

      if (!S.shape || !S.size) {
        /* nothing decided yet — never open on "custom quote" */
        if (v) v.textContent = '—';
        if (s) s.textContent = 'Your estimate appears as you answer.';
      } else if (q.manual) {
        if (v) v.textContent = 'Custom quote';
        if (s) s.textContent = 'We’ll price this one by hand.';
      } else if (q.productTotal > 0) {
        if (v) v.textContent = money(q.overall);
        if (s) s.textContent = q.serviceTotal > 0
          ? money(q.productTotal) + ' cover  +  ' + money(q.serviceTotal) + ' services'
          : 'Cover only — no services added';
      } else {
        if (v) v.textContent = '—';
        if (s) s.textContent = 'Your estimate appears as you answer.';
      }

      if (list) {
        list.innerHTML = '';
        var shown = q.spec.filter(function (p) { return p[1] && p[1] !== 'Not required'; });
        shown.forEach(function (p) {
          var li = el('li');
          li.appendChild(el('span', 'k', p[0]));
          li.appendChild(el('span', 'v', p[1]));
          list.appendChild(li);
        });
        if (empty) empty.hidden = shown.length > 0;
      }
    });
  };

  /* -------------------------------------------------- booking form handoff */
  Calculator.prototype.summaryText = function (q) {
    var L = [];
    L.push('--- SAFETY COVER CONFIGURATION ---');
    q.spec.forEach(function (p) { L.push(p[0] + ': ' + p[1]); });
    if (this.state.hasSteps) {
      L.push('Step position: ' + (this.state.stepPos || 'not given'));
      L.push('Step type: ' + (this.state.stepType || 'not given'));
      L.push('Step size: ' + (this.state.stepDims || 'not given'));
    }
    if (this.state.intent === 'replacement') {
      L.push('Existing template: ' + (this.state.template || 'not given'));
      L.push('Existing anchors: ' + (this.state.anchorState || 'not asked') +
        (this.state.anchorState === 'known' ? ' (' + this.state.anchorQty + ' to replace)' : ''));
    }
    if (this.state.cutLadder) L.push('Ladder/slide-leg cut-outs: ' + this.state.cutLadder);
    if (this.state.cutRock) L.push('Diving rock cut-outs: ' + this.state.cutRock);
    if (this.state.obstruction === 'yes') L.push('Obstruction reported: ' + (this.state.obstructionNote || 'no description given'));

    L.push('');
    if (q.manual) {
      L.push('--- MANUAL REVIEW REQUIRED ---');
      L.push(q.manual);
    } else {
      L.push('--- PRODUCT ---');
      q.product.forEach(function (l) { L.push('  ' + l.lbl + ' ... ' + (l.tbd ? 'TO BE CONFIRMED' : money(l.amt))); });
      L.push('  Product subtotal: ' + money(q.productTotal));
      L.push('');
      L.push('--- SERVICES ---');
      if (q.service.length) {
        q.service.forEach(function (l) { L.push('  ' + l.lbl + ' ... ' + (l.tbd ? 'TO BE CONFIRMED' : money(l.amt))); });
        L.push('  Services subtotal: ' + money(q.serviceTotal));
      } else { L.push('  None selected (product only)'); }
      L.push('');
      L.push('ESTIMATED OVERALL TOTAL: ' + money(q.overall));
    }
    L.push('');
    L.push(this.DB.rules.tax_note);
    return L.join('\n');
  };

  Calculator.prototype.clearFormSummary = function () {
    var f = $('[data-pbsc-quotefield]'); if(f) f.value='No estimate was completed — this enquiry came from the page directly.';
    var recap=$('[data-pbsc-recap]');if(recap)recap.innerHTML='';
    var ready=$('[data-pbsc-recap-ready]'), wait=$('[data-pbsc-recap-wait]');if(ready)ready.hidden=true;if(wait)wait.hidden=false;
  };

  Calculator.prototype.pushToForm = function (q) {
    var C = this;
    var hidden = $('[data-pbsc-quotefield]');
    if (hidden) hidden.value = this.summaryText(q);
    var recap = $('[data-pbsc-recap]');
    if (recap) {
      recap.innerHTML = '';
      var rows = q.spec.slice();
      if (q.manual) { rows.push(['Status', 'Custom quote required']); }
      else {
        rows.push(['Product', money(q.productTotal)]);
        rows.push(['Services', q.service.length ? money(q.serviceTotal) : 'None selected']);
        rows.push(['Estimated total', money(q.overall)]);
      }
      rows.forEach(function (p) {
        var li = el('li');
        li.appendChild(el('span', 'k', p[0]));
        li.appendChild(el('span', 'v', p[1]));
        recap.appendChild(li);
      });
    }
    var ready = $('[data-pbsc-recap-ready]');
    if (ready) ready.hidden = false;
    var wait = $('[data-pbsc-recap-wait]');
    if (wait) wait.hidden = true;
  };

  Calculator.prototype.toBooking = function (q) {
    this.pushToForm(q);
    var t = $('#safety-cover-booking');
    if (t) {
      t.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
      var f = $('input,select,textarea', t);
      if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, reduceMotion() ? 0 : 620);
    }
  };

  /* ==================================================================
     PAGE INTERACTIONS
     ================================================================== */
  function initReveals(scope) {
    var items = $$('.pbsc-rv', scope);
    if (!items.length) return;
    if (reduceMotion() || !('IntersectionObserver' in window)) {
      items.forEach(function (n) { n.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (n) { io.observe(n); });
  }

  function initAccordions(scope) {
    $$('.pbsc-acc__q', scope).forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (open) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () { panel.style.height = '0px'; });
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          panel.addEventListener('transitionend', function te() {
            panel.style.height = 'auto';
            panel.removeEventListener('transitionend', te);
          });
        }
      });
    });
  }

  function initGallery(scope) {
    var gal = $('[data-pbsc-gallery]', scope);
    var lb = $('[data-pbsc-lightbox]');
    if (!gal || !lb) return;
    var btns = $$('.pbsc-gal__btn', gal);
    if (!btns.length) return;
    var img = $('[data-pbsc-lb-img]', lb);
    var cap = $('[data-pbsc-lb-cap]', lb);
    var idx = 0, lastFocus = null, oldOverflow = ''; 

    function show(i) {
      idx = (i + btns.length) % btns.length;
      var src = btns[idx].getAttribute('data-full') || $('img', btns[idx]).src;
      var alt = $('img', btns[idx]).alt || '';
      var c = btns[idx].getAttribute('data-caption') || '';
      img.src = src; img.alt = alt; cap.textContent = c;
    }
    function open(i) {
      lastFocus = document.activeElement;
      show(i); lb.hidden = false;
      oldOverflow=document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden';
      $('[data-pbsc-lb-close]', lb).focus();
      document.addEventListener('keydown', key);
    }
    function close() {
      lb.hidden = true;
      document.documentElement.style.overflow = oldOverflow;
      document.removeEventListener('keydown', key);
      if (lastFocus) lastFocus.focus();
    }
    function key(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
      else if (e.key === 'Tab') {
        var f = $$('button', lb);
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    btns.forEach(function (b, i) { b.addEventListener('click', function () { open(i); }); });
    $('[data-pbsc-lb-close]', lb).addEventListener('click', close);
    var p = $('[data-pbsc-lb-prev]', lb), n = $('[data-pbsc-lb-next]', lb);
    if (p) p.addEventListener('click', function () { show(idx - 1); });
    if (n) n.addEventListener('click', function () { show(idx + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
  }

  /* ------------------------------------------------------------------
     Hero: a tensioned safety cover, drawn.
     Runs only when no hero photograph has been set. The mesh starts slack
     and pulls taut over the first couple of seconds, then breathes very
     slowly. With reduced motion it is drawn once, taut, and left alone.
     ------------------------------------------------------------------ */
  function initHeroMesh(scope) {
    var cv = $('[data-pbsc-mesh]', scope);
    if (!cv || !cv.getContext) return;
    var ctx = cv.getContext('2d');
    var W = 0, H = 0, dpr = 1;
    var COLS = 26, ROWS = 15;
    var start = null, raf = null;
    var still = reduceMotion();

    function size() {
      if (!ctx) return;
      var r = cv.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = Math.max(1, r.width); H = Math.max(1, r.height);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function pt(u, v, sag) {
      var spread = 0.42 + 0.92 * v;                 /* perspective widening  */
      var x = W / 2 + (u - 0.5) * W * spread;
      var y = H * 0.30 + Math.pow(v, 1.42) * H * 0.78;
      y += sag * Math.sin(Math.PI * u) * Math.sin(Math.PI * v);
      return [x, y];
    }

    function draw(t) {
      var sag;
      if (still) { sag = 9; }
      else {
        var e = Math.min(1, t / 2400);
        e = 1 - Math.pow(1 - e, 3);                 /* easeOutCubic          */
        sag = 108 - 99 * e + Math.sin(t / 2600) * 2.4 * e;
      }
      ctx.clearRect(0, 0, W, H);
      ctx.lineWidth = 1;

      var i, j, p;
      for (j = 0; j <= ROWS; j++) {
        var v = j / ROWS;
        ctx.beginPath();
        for (i = 0; i <= COLS; i++) {
          p = pt(i / COLS, v, sag);
          i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]);
        }
        ctx.strokeStyle = 'rgba(242,244,245,' + (0.03 + 0.13 * v).toFixed(3) + ')';
        ctx.stroke();
      }
      for (i = 0; i <= COLS; i++) {
        var u = i / COLS;
        ctx.beginPath();
        for (j = 0; j <= ROWS; j++) {
          p = pt(u, j / ROWS, sag);
          j ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]);
        }
        ctx.strokeStyle = 'rgba(242,244,245,' + (0.03 + 0.075 * (1 - Math.abs(u - 0.5) * 2)).toFixed(3) + ')';
        ctx.stroke();
      }
      /* anchor points along the perimeter, in glacier */
      ctx.fillStyle = 'rgba(158,197,212,.5)';
      for (i = 0; i <= COLS; i += 2) {
        p = pt(i / COLS, 1, sag);
        ctx.beginPath(); ctx.arc(p[0], p[1], 1.6, 0, 6.2832); ctx.fill();
      }
    }

    function loop(ts) {
      if (start === null) start = ts;
      draw(ts - start);
      raf = requestAnimationFrame(loop);
    }

    size();
    if (still) { draw(0); }
    else { raf = requestAnimationFrame(loop); }

    var to;
    window.addEventListener('resize', function () {
      clearTimeout(to);
      to = setTimeout(function () { size(); if (still) draw(0); }, 160);
    }, { passive: true });

    /* stop painting when the hero has scrolled away */
    if ('IntersectionObserver' in window && !still) {
      new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { if (!raf) raf = requestAnimationFrame(loop); }
          else if (raf) { cancelAnimationFrame(raf); raf = null; }
        });
      }, { threshold: 0 }).observe(cv);
    }
  }


  /* ==================================================================
     SCROLL-SEQUENCE HERO
     A pinned plate whose canvas is scrubbed by scroll position. Seven
     stages take the pool from open water in September to clear water in
     April. Everything is drawn — no photography required — so the hero
     works on day one and can be swapped for film later.
     ================================================================== */

  /* ------------------------------------------------- film hero (scrub) ---
     One continuous scene, driven directly by scroll position. Two backends:

     FRAMES — the primary. The footage is decomposed into a dense run of
     stills; each paint blends the two frames either side of the current
     scroll position on a canvas, so the scene moves with the wheel the way
     a video would, runs backwards identically, and never depends on
     <video> seeking (which stutters on iOS). This is the technique big
     product-page scrubs use, and it is why this hero does not feel like a
     slideshow: nothing "advances" — the scene simply sits wherever your
     scroll has put it.

     VIDEO — fallback for a Shopify-hosted MP4, easing currentTime toward
     the scroll target. Used when no frame manifest is present. */
  function initFilmHero(scope) {
    var root = $('[data-pbsc-fhero]', scope);
    if (!root) return;

    var caps = $$('.pbsc-fhero__cap', root);
    var idxOut = $('[data-pbsc-fhero-idx]', root);
    var fill = $('[data-pbsc-fhero-fill]', root);
    var cta = $('[data-pbsc-fhero-cta]', root);
    var hint = $('[data-pbsc-fhero-hint]', root);
    var still = reduceMotion();

    var marks = caps.map(function (c) {
      return Math.max(0, Math.min(1, (parseFloat(c.getAttribute('data-at')) || 0) / 100));
    });
    var lastCap = -1;

    function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

    /* Some themes put overflow:hidden on an ancestor of the page content,
       which silently disables position:sticky. overflow:clip clips exactly
       the same way but does NOT create a scroll container, so sticky keeps
       working — swap hidden for clip on every ancestor. Genuine scroll
       containers (auto/scroll) are left alone. */
    (function unblockSticky() {
      var el = root.parentElement;
      while (el && el.closest('#pbsc-sc-root')) {
        var cs = getComputedStyle(el);
        var sx = cs.overflowX, sy = cs.overflowY;
        /* One axis set to hidden makes the other axis *report* auto even
           when nothing scrolls — so "is this a real scroller" has to be
           judged by whether it can actually scroll, not by the keyword. */
        var scrollsY = (sy === 'auto' || sy === 'scroll') && el.scrollHeight > el.clientHeight + 4;
        var scrollsX = (sx === 'auto' || sx === 'scroll') && el.scrollWidth > el.clientWidth + 4;
        if (sx === 'hidden' && !scrollsY) el.style.overflowX = 'clip';
        if (sy === 'hidden' && !scrollsX) el.style.overflowY = 'clip';
        el = el.parentElement;
      }
    })();

    /* Safety net for browsers without overflow:clip, or scroll-container
       ancestors we can't touch: detect a dead pin mid-scrub and fall back
       to a single-screen hero scrubbed by its transit through the viewport. */
    var pin = $('.pbsc-fhero__pin', root);
    var noSticky = false, stickyChecked = false;
    function checkSticky(r) {
      if (stickyChecked || !pin) return;
      if (r.top < -120 && r.bottom > window.innerHeight + 120) {
        stickyChecked = true;
        if (Math.abs(pin.getBoundingClientRect().top) > 80) {
          noSticky = true;
          root.classList.add('pbsc-fhero--nosticky');
        }
      }
    }

    function progress() {
      var r = root.getBoundingClientRect();
      checkSticky(r);
      if (noSticky) {
        return clamp01((window.innerHeight - r.top) / (window.innerHeight + r.height));
      }
      var span = r.height - window.innerHeight;
      if (span <= 0) return 0;
      return clamp01(-r.top / span);
    }

    function ui(p) {
      if (fill) fill.style.width = (p * 100).toFixed(1) + '%';
      if (cta) cta.setAttribute('data-on', '1'); /* launch pass: buttons from the first frame */
      if (hint) hint.setAttribute('data-off', p > 0.04 ? '1' : '0');
      var i = 0;
      for (var k = 0; k < marks.length; k++) if (p >= marks[k]) i = k;
      if (i === lastCap) return;
      lastCap = i;
      caps.forEach(function (c, k) { c.setAttribute('data-on', k === i ? '1' : '0'); });
      if (idxOut) idxOut.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
    }

    /* ---------------- frame backend ---------------- */
    var fjson = $('[data-pbsc-fhero-frames]', root);
    var cv = $('[data-pbsc-fhero-canvas]', root);
    if (fjson && cv && cv.getContext) {
      var urls;
      try { urls = JSON.parse(fjson.textContent); } catch (e) { urls = null; }
      if (urls && urls.length > 1) { frameBackend(urls); return; }
    }
    var film = $('[data-pbsc-fhero-film]', root);
    if (film) videoBackend(film);

    /* FRAME BACKEND.

       Two defects the first build carried, and why each happened:

       1. THE FIRST SCROLL SAT ON FRAME ONE. Every frame in the run was
          requested in one burst, and a paint whose frame had not arrived yet
          returned without drawing anything at all. So a cold load showed
          frame zero for as long as the tail of the run took to arrive, while
          the scroll — and the captions, and the meter — advanced normally
          underneath it. The second pass looked right only because the whole
          run was then in cache. Fixed two ways that work together: the run
          is fetched as a coarse spine first (both ends, then every eighth
          frame, then the gaps) with a small concurrency window so early
          frames are never queued behind late ones, and a paint that wants a
          missing frame draws the nearest frame that HAS arrived instead of
          drawing nothing. The scene therefore moves on the first wheel tick
          of a fresh load and sharpens as the gaps fill.

       2. THE SCENE SHIFTED HORIZONTALLY BETWEEN FRAMES. The cover fit was
          solved per frame from that frame's own naturalWidth/naturalHeight,
          so a run whose stills differ by even one pixel re-fits — and so
          re-centres — on every blend, which reads as the architecture
          drifting left and right. The destination rectangle is now solved
          ONCE per layout from a single reference aspect (frame zero's) and
          every frame is drawn into exactly that rectangle, rounded to whole
          pixels. The house sits in one coordinate system for the whole
          scrub; only the cover changes. */
    /* A manifest entry may be a bare URL, or an object carrying a phone-sized
       source and a per-frame alignment nudge:

         ["a.jpg", "b.jpg"]
         [{"src":"a.jpg","m":"a-m.jpg","dx":0,"dy":0}, …]

       dx/dy are in the frame's own pixels and say how far to move THAT frame
       so its architecture lines up with the first frame's. They exist because
       the run was generated frame by frame rather than shot from a locked-off
       camera, so the house genuinely sits in a slightly different place in
       each still — up to 18 px across this run, which reads as the scene
       sliding sideways every time two frames cross-fade. Measured once by
       _preview/pbsc-align-frames.py; nothing is computed at runtime. */
    function frames(list) {
      var phone = window.matchMedia && window.matchMedia('(max-width:759px)').matches;
      return list.map(function (e) {
        if (typeof e === 'string') return { src: e, dx: 0, dy: 0 };
        return {
          src: (phone && e.m) ? e.m : e.src,
          dx: Number(e.dx) || 0,
          dy: Number(e.dy) || 0
        };
      }).filter(function (e) { return !!e.src; });
    }

    function frameBackend(list) {
      var urls = frames(list);
      var ctx = cv.getContext('2d');
      var N = urls.length;
      var imgs = new Array(N);
      var ready = 0, shown = false;
      var want = 0, at = 0, lastKey = '';
      var W = 0, H = 0, dpr = 1;
      /* one reference aspect for the whole run — see defect 2 above */
      var refW = 0, refH = 0, refFixed = false;
      var dx = 0, dy = 0, dw = 0, dh = 0;
      var raf = 0, live = true;
      var holdAt = Math.round((N - 1) * 0.62);

      /* The vertical bias lives in CSS so the poster still, the video
         fallback and this canvas all frame the scene identically — without
         it the still is centred, the canvas is not, and the handoff jumps. */
      var bias = parseFloat(getComputedStyle(root).getPropertyValue('--pb-fhero-bias'));
      if (!isFinite(bias)) bias = 58;
      bias = bias / 100;

      function geometry() {
        if (!refW || !refH || !W || !H) return;
        var s = Math.max(W / refW, H / refH);
        dw = refW * s; dh = refH * s;
        /* whole pixels: a fractional destination is what makes a locked
           frame look like it is breathing */
        dx = Math.round((W - dw) / 2);
        dy = Math.round((H - dh) * bias);
        dw = Math.round(dw); dh = Math.round(dh);
      }

      function size() {
        var r = cv.getBoundingClientRect();
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        W = Math.max(1, Math.round(r.width)); H = Math.max(1, Math.round(r.height));
        cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.imageSmoothingEnabled = true;
        if ('imageSmoothingQuality' in ctx) ctx.imageSmoothingQuality = 'high';
        geometry();
        lastKey = '';
      }

      /* Nearest arrived frame. The spine guarantees one within a few
         indices on a cold load, which is what turns "nothing is drawn" into
         "the scene is slightly coarse for a moment". */
      function nearestReady(i) {
        if (i < 0) i = 0; else if (i > N - 1) i = N - 1;
        if (imgs[i] && imgs[i]._ok) return i;
        for (var d = 1; d < N; d++) {
          var a = i - d, b = i + d;
          if (a >= 0 && imgs[a] && imgs[a]._ok) return a;
          if (b < N && imgs[b] && imgs[b]._ok) return b;
        }
        return -1;
      }

      function paint(img, alpha) {
        ctx.globalAlpha = alpha;
        /* the correction is expressed in the frame's pixels, so it scales
           with the frame */
        var k = refW ? dw / refW : 1;
        ctx.drawImage(img,
          dx + Math.round((img._dx || 0) * k),
          dy + Math.round((img._dy || 0) * k),
          dw, dh);
      }

      function render(t) {
        if (!dw || !dh) return;
        t = Math.max(0, Math.min(N - 1, t));
        var i = Math.floor(t), f = t - i;
        if (i >= N - 1) { i = N > 1 ? N - 2 : 0; f = 1; }
        var ia = nearestReady(i);
        if (ia < 0) return;                    /* nothing has arrived yet */
        var ib = f > 0.001 ? nearestReady(i + 1) : -1;
        /* the key names which frames were actually available, so the paint
           repeats the moment a better one lands rather than being skipped */
        var key = ia + '>' + ib + ':' + f.toFixed(3) + ':' + W + 'x' + H;
        if (key === lastKey) return;
        lastKey = key;
        paint(imgs[ia], 1);
        if (ib >= 0 && ib !== ia) paint(imgs[ib], f);
        ctx.globalAlpha = 1;
      }

      function tick() {
        raf = 0;
        var p = progress();
        want = p * (N - 1);
        /* eased follower: a flicked wheel glides rather than steps */
        at += (want - at) * 0.18;
        if (Math.abs(want - at) < 0.002) at = want;
        render(at);
        ui(p);
        if (live) raf = requestAnimationFrame(tick);
      }
      function start() { if (live && !raf) raf = requestAnimationFrame(tick); }
      function stop() { if (raf) { cancelAnimationFrame(raf); raf = 0; } }

      function remeasure() {
        size(); lastCap = -1;
        render(still ? holdAt : at);
      }

      /* Load order decides whether the FIRST scroll has anything to show:
         a coarse spine across the whole run, then the gaps. */
      var queue = [];
      if (still) {
        queue = holdAt === 0 ? [0] : [holdAt, 0];
      } else {
        var seen = {};
        var push = function (k) {
          if (k >= 0 && k < N && !seen[k]) { seen[k] = 1; queue.push(k); }
        };
        push(0); push(N - 1);
        for (var step = 8; step >= 1; step = step >> 1) {
          for (var k = 0; k < N; k += step) push(k);
          if (step === 1) break;
        }
        for (var j = 0; j < N; j++) push(j);   /* belt and braces */
      }

      var qi = 0, inflight = 0, MAX = 6;
      function pump() {
        while (inflight < MAX && qi < queue.length) load(queue[qi++]);
      }

      function load(k) {
        if (imgs[k]) return;
        var im = new Image();
        im.decoding = 'async';
        if (k === 0) { try { im.fetchPriority = 'high'; } catch (e) {} }
        imgs[k] = im;
        inflight++;
        function done(ok) {
          inflight--;
          if (ok) {
            im._ok = true; ready++;
            /* frame zero owns the reference aspect; an earlier arrival only
               stands in until it gets here */
            if (!refFixed && (k === 0 || !refW)) {
              refW = im.naturalWidth; refH = im.naturalHeight;
              if (k === 0) refFixed = true;
              geometry();
            }
            lastKey = '';                      /* a better frame landed */
            if (!shown) { shown = true; root.setAttribute('data-ready', '1'); }
            if (ready === N) root.setAttribute('data-all', '1');
            if (still && k === holdAt) render(holdAt);
          }
          pump();
        }
        im.onload = function () {
          if (im.decode) { im.decode().then(function () { done(true); }, function () { done(true); }); }
          else done(true);
        };
        im.onerror = function () { done(false); };
        im._dx = urls[k].dx;
        im._dy = urls[k].dy;
        im.src = urls[k].src;
      }

      /* A ResizeObserver on the canvas catches what a resize listener
         misses: a scrollbar appearing, the address bar collapsing on a
         phone, a late webfont changing the pin's height after the first
         measurement. */
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(function () { remeasure(); }).observe(cv);
      } else {
        window.addEventListener('resize', remeasure, { passive: true });
      }
      if (document.readyState !== 'complete') {
        window.addEventListener('load', remeasure, { once: true });
      }

      size();
      pump();

      /* reduced motion: the pin is dropped by CSS and every caption is
         shown; one settled mid-winter frame is held as the picture. No
         scroll loop, no rAF. */
      if (still) return;

      /* The loop is parked while the hero is off-screen or the tab is
         hidden — the old build ran an unbroken rAF for the life of the
         page. It starts immediately so a scroll that happens before the
         observer has reported still works. */
      if (typeof IntersectionObserver !== 'undefined') {
        new IntersectionObserver(function (es) {
          live = es[0].isIntersecting;
          if (live) start(); else stop();
        }, { rootMargin: '250px 0px' }).observe(root);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else start();
      });

      start();
    }

    /* ---------------- video backend ---------------- */
    function videoBackend(film) {
      var dur = 0, want = 0, at = 0, unlocked = false;
      film.pause(); film.muted = true;

      function tick() {
        var p = progress();
        want = p * Math.max(0, dur - 0.05);
        at += (want - at) * 0.16;
        if (Math.abs(want - at) < 0.004) at = want;
        if (dur && !film.seeking && isFinite(at)) {
          try { film.currentTime = at; } catch (e) {}
        }
        ui(p);
        requestAnimationFrame(tick);
      }
      function start() {
        dur = film.duration || 0;
        if (!dur || !isFinite(dur)) return;
        root.setAttribute('data-ready', '1');
        if (still) {
          try { film.currentTime = dur * 0.62; } catch (e) {}
          return;
        }
        tick();
      }
      if (film.readyState >= 1) start();
      else film.addEventListener('loadedmetadata', start);

      function unlock() {
        if (unlocked) return;
        unlocked = true;
        var pr = film.play();
        if (pr && pr.then) pr.then(function () { film.pause(); }).catch(function () {});
        else { try { film.pause(); } catch (e) {} }
      }
      ['touchstart', 'pointerdown', 'keydown'].forEach(function (ev) {
        window.addEventListener(ev, unlock, { once: true, passive: true });
      });
    }

    window.addEventListener('resize', function () { lastCap = -1; }, { passive: true });
  }

  function initScrollHero(scope) {
    var root = $('[data-pbsc-shero]', scope);
    if (!root) return;

    /* Photographic mode when stage plates have been uploaded; the drawn
       canvas is the fallback until they are. */
    var plates = $$('.pbsc-shero__plate', root);
    var photo = plates.length > 0;
    var cv = $('[data-pbsc-shero-canvas]', root);
    var ctx = (!photo && cv && cv.getContext) ? cv.getContext('2d') : null;
    if (!photo && !ctx) return;

    var caps = $$('.pbsc-shero__cap', root);
    var idxOut = $('[data-pbsc-shero-idx]', root);
    var fill = $('[data-pbsc-shero-fill]', root);
    var cta = $('[data-pbsc-shero-cta]', root);
    var hint = $('[data-pbsc-shero-hint]', root);
    var still = reduceMotion();

    /* --- stage parameters ------------------------------------------- */
    var STAGES = [
      /* 0 late September  */ { water:1, warm:1.00, anchors:0, cover:0,   sag:1,   leaves:0,   snow:0, light:1.00 },
      /* 1 anchors set     */ { water:1, warm:0.85, anchors:1, cover:0,   sag:1,   leaves:0,   snow:0, light:0.95 },
      /* 2 cover laid out  */ { water:1, warm:0.68, anchors:1, cover:0.5, sag:1,   leaves:0,   snow:0, light:0.88 },
      /* 3 tensioned       */ { water:1, warm:0.50, anchors:1, cover:1,   sag:0.10,leaves:0,   snow:0, light:0.82 },
      /* 4 October         */ { water:1, warm:0.32, anchors:1, cover:1,   sag:0.10,leaves:1,   snow:0, light:0.72 },
      /* 5 January         */ { water:1, warm:0.04, anchors:1, cover:1,   sag:0.17,leaves:0.35,snow:1, light:0.60 },
      /* 6 April           */ { water:1, warm:0.62, anchors:1, cover:0,   sag:1,   leaves:0,   snow:0, light:1.05 }
    ];
    var N = photo
      ? Math.max(2, plates.length)
      : Math.max(2, Math.min(STAGES.length, caps.length || STAGES.length));
    root.style.setProperty('--pb-stages', N);

    /* --- deterministic scatter (seeded once) ------------------------ */
    function scatter(n, seed) {
      var a = [], x = seed;
      for (var i = 0; i < n; i++) {
        x = (x * 1103515245 + 12345) % 2147483648;
        var r1 = x / 2147483648;
        x = (x * 1103515245 + 12345) % 2147483648;
        var r2 = x / 2147483648;
        x = (x * 1103515245 + 12345) % 2147483648;
        var r3 = x / 2147483648;
        a.push({ u: r1, v: r2, s: r3 });
      }
      return a;
    }
    var LEAVES = scatter(58, 7331);
    var SNOW = scatter(240, 9173);

    var W = 0, H = 0, dpr = 1, prog = 0, cur = -1, raf = null, inView = true;

    function size() {
      if (!ctx) return;
      var r = cv.getBoundingClientRect();
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      W = Math.max(1, r.width); H = Math.max(1, r.height);
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function lerp(a, b, t) { return a + (b - a) * t; }
    function mix(c1, c2, t) {
      return 'rgb(' + Math.round(lerp(c1[0], c2[0], t)) + ',' +
                      Math.round(lerp(c1[1], c2[1], t)) + ',' +
                      Math.round(lerp(c1[2], c2[2], t)) + ')';
    }
    function params(f) {
      var i = Math.max(0, Math.min(N - 1, Math.floor(f)));
      var j = Math.min(N - 1, i + 1);
      var t = f - i, o = {}, k;
      for (k in STAGES[i]) o[k] = lerp(STAGES[i][k], STAGES[j][k], t);
      return o;
    }

    /* pool surface in perspective: u across, v far(0) -> near(1) */
    function pool(u, v) {
      var hw = (0.185 + 0.235 * v) * W;
      return [W * 0.5 + (u - 0.5) * 2 * hw, (0.435 + 0.445 * v) * H];
    }
    function deck(u, v) {
      var hw = (0.33 + 0.62 * v) * W;
      return [W * 0.5 + (u - 0.5) * 2 * hw, (0.405 + 0.60 * v) * H];
    }
    function poly(fn, pad) {
      var p = pad || 0, i, q;
      ctx.beginPath();
      for (i = 0; i <= 24; i++) { q = fn(-p + (1 + 2 * p) * i / 24, -p); i ? ctx.lineTo(q[0], q[1]) : ctx.moveTo(q[0], q[1]); }
      for (i = 24; i >= 0; i--) { q = fn(-p + (1 + 2 * p) * i / 24, 1 + p); ctx.lineTo(q[0], q[1]); }
      ctx.closePath();
    }

    function draw(t) {
      var P = params(prog * (N - 1));
      var L = P.light;

      /* backdrop */
      var g = ctx.createLinearGradient(0, 0, 0, H);
      g.addColorStop(0, mix([12, 18, 26], [20, 27, 36], P.warm));
      g.addColorStop(0.42, mix([9, 12, 17], [15, 20, 27], P.warm));
      g.addColorStop(1, '#07090C');
      ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);

      /* deck plane */
      poly(deck, 0);
      ctx.fillStyle = mix([15, 18, 23], [26, 26, 27], P.warm);
      ctx.fill();
      /* paving joints, fading with distance */
      ctx.lineWidth = 1;
      for (var d = 1; d < 7; d++) {
        var v = d / 7, a = 0.05 * v;
        ctx.beginPath();
        var p0 = deck(0, v), p1 = deck(1, v);
        ctx.moveTo(p0[0], p0[1]); ctx.lineTo(p1[0], p1[1]);
        ctx.strokeStyle = 'rgba(242,244,245,' + a.toFixed(3) + ')';
        ctx.stroke();
      }

      /* basin */
      poly(pool, 0);
      ctx.fillStyle = '#05080B'; ctx.fill();

      /* water */
      ctx.save();
      poly(pool, 0); ctx.clip();
      var wg = ctx.createLinearGradient(0, H * 0.43, 0, H * 0.9);
      wg.addColorStop(0, mix([16, 44, 56], [38, 112, 132], P.warm));
      wg.addColorStop(1, mix([9, 26, 34], [20, 72, 90], P.warm));
      ctx.globalAlpha = P.water * L;
      ctx.fillStyle = wg; ctx.fillRect(0, 0, W, H);
      /* shimmer */
      var drift = still ? 0 : t / 5200;
      for (var sI = 0; sI < 7; sI++) {
        var sv = ((sI / 7) + drift % 1) % 1;
        var a0 = pool(0, sv), a1 = pool(1, sv);
        ctx.globalAlpha = P.water * L * 0.1 * (1 - Math.abs(sv - .5) * 1.3);
        ctx.lineWidth = 1 + sv * 2.5;
        ctx.strokeStyle = 'rgba(230,246,250,1)';
        ctx.beginPath(); ctx.moveTo(a0[0], a0[1]); ctx.lineTo(a1[0], a1[1]); ctx.stroke();
      }
      ctx.restore();
      ctx.globalAlpha = 1;

      /* coping edge */
      poly(pool, 0);
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(242,244,245,' + (0.16 * L).toFixed(3) + ')';
      ctx.stroke();

      /* anchors — two-piece brass, set into the deck just off the coping */
      if (P.anchors > 0.01) {
        ctx.globalAlpha = P.anchors;
        var dot = function (x, y, v) {
          var rad = 1.2 + 1.8 * v;
          ctx.beginPath(); ctx.arc(x, y, rad, 0, 6.2832);
          ctx.fillStyle = 'rgba(158,197,212,.78)'; ctx.fill();
          ctx.beginPath(); ctx.arc(x - rad * .3, y - rad * .3, rad * .38, 0, 6.2832);
          ctx.fillStyle = 'rgba(242,248,250,.75)'; ctx.fill();
        };
        var e, q5;
        for (e = 0; e <= 15; e++) {                       /* far edge  */
          q5 = pool(e / 15, 0); dot(q5[0], q5[1] - 5, 0);
        }
        for (e = 0; e <= 15; e++) {                       /* near edge */
          q5 = pool(e / 15, 1); dot(q5[0], q5[1] + 16, 1);
        }
        for (e = 1; e < 9; e++) {                         /* left      */
          var lv = e / 9; q5 = pool(0, lv); dot(q5[0] - (7 + 15 * lv), q5[1] + 3 * lv, lv);
        }
        for (e = 1; e < 9; e++) {                         /* right     */
          var rv = e / 9; q5 = pool(1, rv); dot(q5[0] + (7 + 15 * rv), q5[1] + 3 * rv, rv);
        }
        ctx.globalAlpha = 1;
      }

      /* the cover */
      if (P.cover > 0.01) {
        var COLS = 22, ROWS = 13, OV = 0.075;
        var sag = P.sag * H * 0.052;
        var cp = function (u, v) {
          var q = pool(-OV + u * (1 + 2 * OV), -OV + v * (1 + 2 * OV));
          return [q[0], q[1] + sag * Math.sin(Math.PI * u) * Math.sin(Math.PI * v)];
        };
        /* fabric */
        ctx.save();
        ctx.beginPath();
        var i3, q3;
        for (i3 = 0; i3 <= COLS; i3++) { q3 = cp(i3 / COLS, 0); i3 ? ctx.lineTo(q3[0], q3[1]) : ctx.moveTo(q3[0], q3[1]); }
        for (i3 = 0; i3 <= ROWS; i3++) { q3 = cp(1, i3 / ROWS); ctx.lineTo(q3[0], q3[1]); }
        for (i3 = COLS; i3 >= 0; i3--) { q3 = cp(i3 / COLS, 1); ctx.lineTo(q3[0], q3[1]); }
        for (i3 = ROWS; i3 >= 0; i3--) { q3 = cp(0, i3 / ROWS); ctx.lineTo(q3[0], q3[1]); }
        ctx.closePath();
        ctx.fillStyle = 'rgba(22,28,34,' + (0.5 * P.cover).toFixed(3) + ')';
        ctx.fill();
        ctx.clip();

        /* snow load sits on the fabric */
        if (P.snow > 0.01) {
          ctx.fillStyle = 'rgba(236,242,246,' + (0.17 * P.snow).toFixed(3) + ')';
          ctx.fillRect(0, 0, W, H);
        }
        ctx.restore();

        /* webbing */
        ctx.lineWidth = 1;
        var wa = 0.2 * P.cover;
        var j4, i4, q4;
        for (j4 = 0; j4 <= ROWS; j4++) {
          ctx.beginPath();
          for (i4 = 0; i4 <= COLS; i4++) { q4 = cp(i4 / COLS, j4 / ROWS); i4 ? ctx.lineTo(q4[0], q4[1]) : ctx.moveTo(q4[0], q4[1]); }
          ctx.strokeStyle = 'rgba(242,244,245,' + (wa * (0.35 + 0.65 * j4 / ROWS)).toFixed(3) + ')';
          ctx.stroke();
        }
        for (i4 = 0; i4 <= COLS; i4++) {
          ctx.beginPath();
          for (j4 = 0; j4 <= ROWS; j4++) { q4 = cp(i4 / COLS, j4 / ROWS); j4 ? ctx.lineTo(q4[0], q4[1]) : ctx.moveTo(q4[0], q4[1]); }
          ctx.strokeStyle = 'rgba(242,244,245,' + (wa * 0.6).toFixed(3) + ')';
          ctx.stroke();
        }
        /* straps out to the anchors */
        ctx.strokeStyle = 'rgba(242,244,245,' + (0.3 * P.cover).toFixed(3) + ')';
        for (i4 = 0; i4 <= COLS; i4 += 2) {
          var a = cp(i4 / COLS, 1), b = pool(i4 / COLS, 1);
          b = [b[0], b[1] + 16];
          ctx.beginPath(); ctx.moveTo(a[0], a[1]); ctx.lineTo(b[0], b[1]); ctx.stroke();
        }

        /* leaves, then snow, resting on the surface */
        if (P.leaves > 0.01) {
          LEAVES.forEach(function (l) {
            var q = cp(l.u, l.v);
            ctx.globalAlpha = P.leaves * (0.5 + l.s * 0.5);
            ctx.fillStyle = l.s > 0.55 ? '#8A6236' : '#6E4A2B';
            ctx.beginPath();
            ctx.ellipse(q[0], q[1], 2.4 + l.v * 3.4, 1.4 + l.v * 2, l.s * 3, 0, 6.2832);
            ctx.fill();
          });
          ctx.globalAlpha = 1;
        }
        if (P.snow > 0.01) {
          SNOW.forEach(function (n2) {
            var q = cp(n2.u, n2.v);
            ctx.globalAlpha = P.snow * (0.35 + n2.s * 0.65);
            ctx.fillStyle = '#F4F8FA';
            ctx.beginPath(); ctx.arc(q[0], q[1], 0.7 + n2.v * 1.7, 0, 6.2832); ctx.fill();
          });
          ctx.globalAlpha = 1;
        }
      }

      /* winter chill wash */
      if (P.warm < 0.4) {
        ctx.globalAlpha = (0.4 - P.warm) * 0.34;
        ctx.fillStyle = '#8FB3C6';
        ctx.globalCompositeOperation = 'overlay';
        ctx.fillRect(0, 0, W, H);
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 1;
      }
    }

    /* --- ui ---------------------------------------------------------- */
    /* Smootherstep. Zero first AND second derivative at both ends, so a
       dissolve driven by it has no visible kick as it starts or stops. */
    function ease(x) {
      x = x < 0 ? 0 : x > 1 ? 1 : x;
      return x * x * x * (x * (x * 6 - 15) + 10);
    }

    /* Each stage occupies one unit of t. HOLD is the fraction of that unit the
       frame sits fully settled before the next one starts coming up; the
       dissolve then runs across the remainder. Holding first and dissolving
       quickly is what reads as authored rather than as a slideshow — a fade
       spread evenly across the whole unit never lets any frame land. */
    var HOLD = 0.30, RUN = 0.62;
    var drift = parseFloat(getComputedStyle(root).getPropertyValue('--pb-shero-drift')) || 0;

    function plateOpacity(k, t) {
      if (k === 0) return 1;                       /* floor plate, always lit */
      return ease((t - (k - 1) - HOLD) / RUN);
    }
    /* A slow push-in that keeps running after the plate has settled, so the
       image is never completely static even while the scroll is paused. */
    function plateScale(k, t) {
      return 1 + (drift / 100) * (1 - ease((t - (k - 1)) / 1.45));
    }

    var lastCap = -1;

    function ui() {
      var t = prog * (N - 1);

      if (fill) fill.style.width = (prog * 100).toFixed(1) + '%';
      if (cta) cta.setAttribute('data-on', t >= 2.4 ? '1' : '0');
      if (hint) hint.setAttribute('data-off', prog > 0.04 ? '1' : '0');

      /* Continuous: rewritten every frame, straight off scroll position. */
      if (photo) {
        for (var k = 0; k < plates.length; k++) {
          var o = plateOpacity(k, t);
          plates[k].style.opacity = o.toFixed(4);
          var img = plates[k].firstElementChild;
          if (img) img.style.transform = 'scale(' + plateScale(k, t).toFixed(4) + ')';
          /* decode the next plate while it is still transparent */
          if (o > 0 && o < 1) {
            var nxt = plates[k + 1] && plates[k + 1].firstElementChild;
            if (nxt && nxt.decode && !nxt.dataset.pbDecoded) {
              nxt.dataset.pbDecoded = '1';
              try { nxt.decode(); } catch (e) {}
            }
          }
        }
      }

      /* Discrete: the caption swaps once, at the midpoint of the dissolve —
         the moment the incoming photograph reaches 50%. Cross-fading two
         blocks of text through each other is unreadable, so this one snaps
         (with its own short CSS fade) while the imagery scrubs. */
      var i = Math.max(0, Math.min(N - 1, Math.floor(t + (1 - HOLD - RUN / 2))));
      if (i === lastCap) return;
      lastCap = cur = i;
      caps.forEach(function (c, k) { c.setAttribute('data-on', k === i ? '1' : '0'); });
      if (idxOut) idxOut.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
    }

    function measure() {
      var r = root.getBoundingClientRect();
      var span = r.height - window.innerHeight;
      prog = span <= 0 ? 0 : Math.max(0, Math.min(1, -r.top / span));
    }

    function frame(ts) {
      if (!still) measure();
      if (ctx) draw(ts || 0);
      ui();
      raf = inView ? requestAnimationFrame(frame) : null;
    }

    size();
    if (still) {
      prog = 1; if (ctx) draw(0); ui();
      caps.forEach(function (c) { c.setAttribute('data-on', '1'); });
      if (photo) plates.forEach(function (pl) {
        pl.style.opacity = '1';
        var img = pl.firstElementChild;
        if (img) img.style.transform = 'none';
      });
    } else {
      measure();
      raf = requestAnimationFrame(frame);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (e) {
            inView = e.isIntersecting;
            if (inView && !raf) raf = requestAnimationFrame(frame);
          });
        }, { threshold: 0 }).observe(root);
      }
    }

    var to;
    window.addEventListener('resize', function () {
      clearTimeout(to);
      to = setTimeout(function () { size(); if (still && ctx) draw(0); }, 150);
    }, { passive: true });
  }

  function initShowroom(scope) {
    var room = $('[data-pbsc-room]', scope);
    if (!room) return;
    var mesh = $('[data-pbsc-room-mesh]', room);
    var nameOut = $('[data-pbsc-room-name]', room);
    var denOut = $('[data-pbsc-room-density]', room);
    var swatches = $$('[data-pbsc-room-swatch]', room);
    var toggles = $$('[data-pbsc-room-den]', room);

    function paint(btn) {
      if (!btn) return;
      swatches.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      var hex = btn.getAttribute('data-hex');
      var img = btn.getAttribute('data-image');
      var name = btn.getAttribute('data-name');
      if (img) { mesh.style.backgroundImage = 'url("' + img + '")'; mesh.style.backgroundSize = 'cover'; }
      else { mesh.style.backgroundImage = ''; }
      if (hex) mesh.style.backgroundColor = hex;
      if (nameOut) nameOut.textContent = name;
      if (window.PBSCDesignCentre) {
        window.PBSCDesignCentre.state.colour = name;
        window.PBSCDesignCentre.save();
        window.PBSCDesignCentre.updateRail();
      }
    }
    function density(btn) {
      toggles.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
      mesh.style.setProperty('--pb-weave', btn.getAttribute('data-weave'));
      if (denOut) denOut.textContent = btn.getAttribute('data-label');
    }

    swatches.forEach(function (b) { b.addEventListener('click', function () { paint(b); }); });
    toggles.forEach(function (b) { b.addEventListener('click', function () { density(b); }); });
    if (swatches[0]) paint(swatches[0]);
    if (toggles[0]) density(toggles[0]);

    document.addEventListener('pbsc-sc:colour', function (e) {
      var match = swatches.filter(function (b) { return b.getAttribute('data-name') === e.detail; })[0];
      if (match) paint(match);
    });
  }

  function initSheet() {
    var sheet = $('[data-pbsc-sheet]');
    if (!sheet) return;

    /* The running-summary sheet is pinned to the bottom of the viewport, so
       keep it off screen until the estimator has actually been reached —
       otherwise it sits on top of the hero. */
    var stage = $('[data-pbsc-root]');
    if (stage && 'IntersectionObserver' in window) {
      sheet.setAttribute('data-ready', '0');
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          sheet.setAttribute('data-ready', e.isIntersecting ? '1' : '0');
          if (!e.isIntersecting) sheet.setAttribute('data-open', '0');
        });
      }, { rootMargin: '0px 0px -20% 0px' });
      io.observe(stage);
    }

    var hd = $('.pbsc-sheet__hd', sheet);
    hd.addEventListener('click', function () {
      var open = sheet.getAttribute('data-open') === '1';
      sheet.setAttribute('data-open', open ? '0' : '1');
      hd.setAttribute('aria-expanded', String(!open));
    });
    var calc = $('.pbsc-calc');
    if (calc) calc.classList.add('is-sheet-live');
  }

  /* ------------------------------------------------- page-style views ----
     Get my price, Services, Warranty and FAQ each become their own view
     rather than another stop on one long scroll, the way the Fiberglass
     Design Centre separates its sections. Everything not named below stays
     together in the Overview view. Nothing is removed from the page — the
     sections are the same sections, just grouped. */
  /* Which view (or views) each section belongs to. A section may appear in
     more than one: the mesh, grid, colour and custom-fit sections carry the
     overview's narrative AND make up the detail view, and duplicating them in
     the DOM to achieve that would duplicate their ids, their controls and
     their listeners. The first entry is the section's home, which is where a
     link to it goes from elsewhere.

     Anything not listed belongs to the overview. '*' means every view, which
     is how the sub-nav and the closing call to action stay put. */
  var VIEW_OF = {
    'safety-cover-materials': ['overview', 'options'],
    'safety-cover-grid': ['overview', 'options'],
    'safety-cover-colours': ['overview', 'options'],
    'safety-cover-customfit': ['overview', 'options'],
    /* The installation photography is real work, and it is phone snapshots:
       scruffy yards, chain fencing, people in shot, flat overcast light. Next
       to the rest of this page it reads as a different company. It stays as
       proof, in the detail view, rather than leading the main narrative. */
    'safety-cover-gallery': ['options'],
    'safety-cover-compare': ['options'],
    'safety-cover-construction': ['options'],
    'safety-cover-band2': ['options'],
    'safety-cover-services': ['services'],
    'safety-cover-process': ['services'],
    'safety-cover-care': ['services'],
    'safety-cover-faq': ['faq'],
    'safety-cover-warranty': ['faq'],
    'safety-cover-booking': ['*']
  };
  var VIEW_ORDER = ['overview', 'options', 'services', 'faq'];

  function viewsOf(id) {
    var v = VIEW_OF[id];
    if (!v) return ['overview'];
    return typeof v === 'string' ? [v] : v;
  }
  function inView(list, name) {
    return list.indexOf('*') > -1 || list.indexOf(name) > -1;
  }

  function initViews(scope) {
    var nav = $('[data-pbsc-subnav]', scope);
    if (!nav) return null;
    /* Flat mode: every section stays on the page in order and the sub-nav
       only scrolls. Set from the sub-nav section's "one page" toggle. */
    var FLAT = nav.hasAttribute('data-pbsc-flat');

    /* The outermost element the theme puts this section in: the .pbsc
       wrapper in a standalone build, the Shopify <section> around it on the
       live theme. Hiding the outer one avoids leaving the theme's own
       section padding behind as a gap. */
    function blockOf(el) {
      var b = el.closest ? el.closest('.pbsc') : null;
      if (!b) return null;
      var p = b.parentElement;
      /* Shopify wraps each section in its own element. Hide that rather than
         the inner wrapper, or the theme's section padding is left behind as a
         gap where the section used to be. Matching on the wrapper's id covers
         every section; matching on a pb-sc-* class only covered the two that
         happen to set one. */
      if (p && p.tagName === 'SECTION' &&
          (p.id.indexOf('pbsc-sc-block') === 0 ||
           p.className.indexOf('pb-sc-') > -1 ||
           p.className.indexOf('pbsc-') > -1)) b = p;
      return b;
    }

    var blocks = [], seen = [];
    $$('.pbsc', scope).forEach(function (w) {
      var b = blockOf(w);
      if (!b || seen.indexOf(b) > -1) return;
      seen.push(b);
      var view = ['overview'], k;
      for (k in VIEW_OF) {
        if (b.querySelector('#' + k)) { view = viewsOf(k); break; }
      }
      /* the sub-nav itself is the chrome, present in every view */
      if (b.querySelector('[data-pbsc-subnav]')) view = ['*'];
      blocks.push({ el: b, view: view });
    });

    var current = null;

    function setView(name, opts) {
      if (VIEW_ORDER.indexOf(name) < 0) name = 'overview';
      opts = opts || {};
      if (name === current && !opts.force) return;
      current = name;

      var lead = null;
      blocks.forEach(function (b) {
        var on = FLAT || inView(b.view, name);
        b.el.classList.toggle('pbsc-view--off', !on);
        b.el.classList.remove('pbsc-view--lead');
        if (on && b.view.indexOf('*') < 0 && !lead) lead = b.el;
      });
      /* The section that now opens the view was designed to be met mid-scroll,
         so its full top padding reads as a gap when it is the first thing
         under the nav. Only the leading section is trimmed. */
      if (lead && !FLAT) lead.classList.add('pbsc-view--lead');

      /* the sub-nav marks the view you are in; inside Overview the existing
         scroll-spy takes over again */
      $$('a[href^="#"]', nav).forEach(function (a) {
        var id = a.getAttribute('href').slice(1);
        if (VIEW_OF[id]) {
          if (viewsOf(id)[0] === name) a.setAttribute('aria-current', 'page');
          else a.removeAttribute('aria-current');
        } else if (name !== 'overview') {
          a.removeAttribute('aria-current');
        } else {
          a.setAttribute('aria-current', 'page');
        }
      });
      nav.setAttribute('data-view', name);

      if (opts.scroll !== false && !FLAT) {
        window.scrollTo({ top: 0, behavior: reduceMotion() ? 'auto' : 'smooth' });
      }
      /* sections that measure themselves were display:none a moment ago */
      window.dispatchEvent(new Event('resize'));
      document.dispatchEvent(new CustomEvent('pbsc-sc:view', { detail: { view: name } }));
    }

    /* Where a link to this section goes: its home view. A section that also
       appears elsewhere is not navigated to in the other place. */
    function viewForId(id) {
      var v = viewsOf(id);
      return v[0] === '*' ? current || 'overview' : v[0];
    }

    /* One handler for both the sub-nav links and every in-page CTA. A target
       in another view switches to it; a target in this one just scrolls. */
    function go(id, e) {
      var view = viewForId(id);
      var t = document.getElementById(id);
      if (!t && view === 'overview') return false;
      if (e) e.preventDefault();
      if (FLAT) {
        if (t) t.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + id);
        return true;
      }
      if (view !== current) {
        setView(view, { scroll: false });
        if (view === 'overview' && t) {
          t.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
        } else {
          window.scrollTo({ top: 0, behavior: 'auto' });
        }
      } else if (t) {
        t.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
      }
      if (history.replaceState) history.replaceState(null, '', '#' + id);
      return true;
    }

    $$('a[href^="#safety-cover-"]', scope).forEach(function (a) {
      a.addEventListener('click', function (e) { go(a.getAttribute('href').slice(1), e); });
    });
    window.addEventListener('hashchange', function () {
      var id = location.hash.slice(1);
      if (id) setView(viewForId(id), { scroll: false });
    });

    setView(viewForId(location.hash.slice(1)), { scroll: false, force: true });
    if ($('[data-pbsc-form-status]', scope)) setTimeout(function(){var status=$('[data-pbsc-form-status]', scope);status.scrollIntoView({block:'center'});status.focus({preventScroll:true});},150);
    if (location.hash) {
      var t0 = document.getElementById(location.hash.slice(1));
      if (t0) setTimeout(function () { t0.scrollIntoView({ block: 'start' }); }, 60);
    }
    return { go: go, setView: setView, viewForId: viewForId };
  }

  /* Scroll-spy, for the one-page arrangement only. With views on, the nav
     marks the view you are in and a spy would fight it for the same
     attribute — the tab would flicker to whatever section happened to be
     crossing the middle of the screen. */
  function initSubnav(scope) {
    var nav = $('[data-pbsc-subnav]', scope);
    if (!nav || !('IntersectionObserver' in window)) return;
    if (!nav.hasAttribute('data-pbsc-flat')) return;
    var links = $$('a[href^="#"]', nav);
    var map = {};
    links.forEach(function (a) {
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if (t) map[t.id] = a;
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          links.forEach(function (a) { a.removeAttribute('aria-current'); });
          if (map[e.target.id]) map[e.target.id].setAttribute('aria-current', 'true');
        }
      });
    }, { rootMargin: '-45% 0px -50% 0px' });
    Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
  }

  function initMaterialToggle(scope, router) {
    $$('[data-pbsc-jump]', scope).forEach(function (b) {
      b.addEventListener('click', function (e) {
        var id = b.getAttribute('data-pbsc-jump');
        /* "Build & price your cover" and friends now cross into the Get my
           price view rather than scrolling to a section further down. */
        if (router && router.go(id, e)) return;
        var t = document.getElementById(id);
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' });
      });
    });
  }

  /* ------------------------------------------------- cover study (lazy) --
     assets/pb-sc-anatomy.js carries three.js, so it is deliberately not a
     <script> in the section. Nothing is fetched until the study is within
     about a screen of the viewport; a visitor who never scrolls that far
     pays nothing, and the section's fallback still is a complete picture
     until then. Loaded once, guarded against the theme editor re-running
     boot on section reload. */
  function initAnatomy(scope) {
    var root = $('[data-pbsc-anat]', scope);
    if (!root) return;
    var src = root.getAttribute('data-anat-src');
    if (!src || root.getAttribute('data-anat-req') === '1') return;

    function load() {
      if (root.getAttribute('data-anat-req') === '1') return;
      root.setAttribute('data-anat-req', '1');
      var sc = document.createElement('script');
      sc.src = src;
      sc.defer = true;
      sc.onerror = function () {
        root.setAttribute('data-anat-fallback', '1');
        var st = $('[data-anat-status]', root);
        if (st) st.textContent = 'The cover study could not load. The components are described below.';
      };
      document.head.appendChild(sc);
    }

    if (typeof IntersectionObserver === 'undefined') { load(); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { obs.disconnect(); load(); return; }
      }
    }, { rootMargin: '700px 0px' });
    io.observe(root);
  }

  /* ------------------------------------------------------------------ boot */
  function boot() {
    var scope = document.getElementById('pbsc-sc-root');
    if (!scope) return;
    scope.classList.add('pbsc-js');
    initReveals(scope);
    initAccordions(scope);
    initGallery(scope);
    initHeroMesh(scope);
    initFilmHero(scope);
    initScrollHero(scope);
    initAnatomy(scope);
    initShowroom(scope);
    initSheet();
    var router = initViews(scope);
    initSubnav(scope);
    initMaterialToggle(scope, router);

    var root = $(ROOT_SEL);
    if (!root) return;

    var url = root.getAttribute('data-pricing');
    if (!url) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('pricing ' + r.status); return r.json(); })
      .then(function (DB) {
        window.PBSCDesignCentre = new Calculator(root, DB);
      })
      .catch(function () {
        var p = $('[data-pbsc-panel]', root);
        if (p) {
          p.innerHTML = '';
          var d = el('div', 'pbsc-err');
          d.hidden = false;
          d.textContent = 'The estimate tool couldn’t load just now. Please refresh the page, or call us on (289) 929-7665 and we’ll price your cover over the phone.';
          p.appendChild(d);
        }
      });
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  }


})();

;
(function(){
 'use strict';
 function init(){
  var nav=document.querySelector('[data-pbsc-subnav]');
  if(nav) nav.closest('.pbsc-sc-block').classList.add('pbsc-nav-wrap');

  // Study controls only change diagrams; never calculator choices or prices.
  var grid=document.querySelector('[data-grid-study]');
  if(grid){
   var drawing=grid.querySelector('[data-grid-drawing]');
   function drawGrid(value){
    var nx=value==='3x3'?10:6,ny=value==='3x3'?5:3;
    var svg='<svg viewBox="0 0 680 330" role="img" aria-label="'+(value==='3x3'?'Denser 3 by 3':'Wider 5 by 5')+' webbing with anchors on the surrounding deck. Schematic, not to scale.">'+
    '<defs><pattern id="grid-weave" width="4" height="4" patternUnits="userSpaceOnUse"><path d="M4 0H0V4" fill="none" stroke="#f7f5ee" stroke-opacity=".25" stroke-width=".5"/></pattern></defs>'+
    '<rect x="60" y="32" width="560" height="256" fill="#dddacf" stroke="#b7bbae"/>'+
    '<path d="M340 32V288M60 160H620" stroke="#c3c6bb" stroke-width=".7"/>'+
    '<rect x="112" y="70" width="456" height="180" fill="#88938a" stroke="#314940" stroke-width="1.2"/>'+
    '<rect x="112" y="70" width="456" height="180" fill="url(#grid-weave)"/>';
    for(var x=0;x<=nx;x++){var px=112+456*x/nx;svg+='<path d="M'+px+' 50V270" stroke="#2d4139" stroke-width="1.6"/><circle cx="'+px+'" cy="50" r="3" fill="#826836"/><circle cx="'+px+'" cy="270" r="3" fill="#826836"/>';}
    for(var y=0;y<=ny;y++){var py=70+180*y/ny;svg+='<path d="M90 '+py+'H590" stroke="#2d4139" stroke-width="1.6"/><circle cx="90" cy="'+py+'" r="3" fill="#826836"/><circle cx="590" cy="'+py+'" r="3" fill="#826836"/>';}
    svg+='<path d="M112 309H568M112 303V315M568 303V315" stroke="#788779" fill="none"/><text x="340" y="326" font-family="Manrope,sans-serif" font-size="10" fill="#4d5d52" text-anchor="middle">SAME POOL OUTLINE · DIFFERENT WEBBING DENSITY</text></svg>';
    drawing.innerHTML=svg;
    grid.querySelector('[data-grid-copy]').textContent=value==='3x3'?'More closely spaced webbing. Standard or Premium High Density Mesh, subject to your pool’s eligibility.':'More widely spaced webbing. Standard Mesh only, subject to your pool’s eligibility.';
    grid.querySelectorAll('button').forEach(function(b){b.setAttribute('aria-pressed',String(b.dataset.grid===value));});
   }
   grid.addEventListener('click',function(e){var b=e.target.closest('[data-grid]');if(b)drawGrid(b.dataset.grid);});drawGrid('3x3');
  }
  var fit=document.querySelector('[data-fit-study]');
  if(fit){
   var copy={measure:'The outline, steps and obstructions are recorded together. The pattern starts with your pool.',pattern:'The cover pattern includes the step section and allows for the obstruction. Nothing is trimmed to fit on site.',fitted:'The finished cover follows that pattern. This is an illustrative study; your details are confirmed at measurement.'};
   fit.addEventListener('click',function(e){var b=e.target.closest('[data-phase-button]');if(!b)return;var phase=b.dataset.phaseButton;fit.dataset.phase=phase;fit.querySelectorAll('button').forEach(function(x){x.setAttribute('aria-pressed',String(x===b));});fit.querySelector('[data-fit-copy]').textContent=copy[phase];});
  }
  // Reflect stage and selection in accessible presentation without changing state.
  var root=document.querySelector('[data-pbsc-root]');
  var previousStage='';
  function present(){
   if(!root)return;
   var current=root.querySelector('[data-pbsc-stepname]'),bar=root.querySelector('[role=progressbar]');
   var stage=['Your pool','Your cover','Your services','Your quote'].indexOf(current?current.textContent.trim():'Your pool')+1;
   if(bar){bar.setAttribute('aria-valuemin','1');bar.setAttribute('aria-valuemax','4');bar.setAttribute('aria-valuenow',String(stage || 4));bar.setAttribute('aria-valuetext',current?current.textContent:'Your pool');}
   root.querySelectorAll('.pbsc-swatch__btn').forEach(function(b){var name=b.querySelector('.pbsc-swatch__name');if(name)b.id='pbsc-colour-'+name.textContent.toLowerCase().replace(/[^a-z]/g,'');});
   if(current && current.textContent!==previousStage){previousStage=current.textContent;root.dataset.currentStage=previousStage;}
  }
  document.addEventListener('pbsc-sc:config',present);present();
  // Accessible names for collapsed step navigation, even at narrow widths.
  if(root){var mo=new MutationObserver(function(){root.querySelectorAll('[data-pbsc-dots] button').forEach(function(b){b.setAttribute('aria-label',Array.from(b.children).map(function(c){return c.textContent.trim();}).join(' '));});present();});mo.observe(root.querySelector('[data-pbsc-dots]'),{childList:true});}
  var sheet=document.querySelector('[data-pbsc-sheet]');
  if(sheet){
   var header=sheet.querySelector('.pbsc-sheet__hd'),body=sheet.querySelector('.pbsc-sheet__bd');
   body.id='pbsc-mobile-summary';header.setAttribute('aria-controls',body.id);
   function syncSheet(){var open=sheet.dataset.open==='1' && sheet.dataset.ready==='1';body.inert=!open;body.setAttribute('aria-hidden',String(!open));header.setAttribute('aria-expanded',String(open));}
   new MutationObserver(syncSheet).observe(sheet,{attributes:true,attributeFilter:['data-open','data-ready']});syncSheet();
   sheet.addEventListener('keydown',function(e){if(e.key==='Escape' && sheet.dataset.open==='1'){sheet.dataset.open='0';header.focus();}});
  }
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

(function(){
 var root=document.getElementById('pbsc-sc-root');if(!root)return;
 var consultation=root.querySelector('[data-pbsc-consultation]');if(consultation)consultation.addEventListener('click',function(){var option=root.querySelector('input[name="contact[Request type]"][value="Book a custom measurement"]');if(option)option.checked=true;});
 if(window.Shopify && Shopify.designMode){document.addEventListener('shopify:section:load',function(e){if(e.target.querySelector('#pbsc-sc-root'))location.reload();});}
 var form=root.querySelector('#pbsc-booking-form');if(form)form.addEventListener('submit',function(){
  var calc=window.PBSCDesignCentre;if(calc){if(calc.firstGap(calc.groups(),3))calc.clearFormSummary();else calc.pushToForm(calc.quote());}
 });
})();
